import * as React from "react";
import {
  CardsContainer,
  MainCards,
  MainCard,
  MainCardTitle,
  MainCardDetails,
  BaseCardsContainer,
  BaseCard,
  MainCardsContainer,
  MyFavorites,
  MyFavoritesCard,
} from "./Cards.styled";
import path from "../../assets/path.svg";
import CC from "../../assets/CC.svg";
import myRequests from "../../assets/myRequests.svg";
import nocs from "../../assets/activeNocs.svg";
import folder from "../../assets/folder.svg";
import bill from "../../assets/bill.svg";
import checkout from "../../assets/checkout.svg";
import DashboardTable from "../Dashboard.simpleTable/DashboardTable";
import StarOutlinedIcon from "@mui/icons-material/StarOutlined";
import StarBorderOutlined from "@mui/icons-material/StarBorderOutlined";
import StarIcon from "@mui/icons-material/Star";

import User from "../../stores/UserStore";
import General from "../../stores/GeneralStore";
import PaymentReceipts from "../../stores/PaymentReceiptsStore";
import NocsRequests from "../../stores/NocsRequestsStore";
import { observer } from "mobx-react";
import { Table, Th, Tr, Td } from "../Dashboard.cards/Cards.styled";
import Carousel1 from "./Carousel";
import { date } from "yup";
import Carousel2 from "./Carousel2";
import { useNavigate } from "react-router-dom";
import { toJS } from "mobx";
import { style } from "@mui/system";
import { Box } from "@mui/material";
import constants from "../../../src/utils/constants";

interface Obj {
  [key: string]: any;
}

const DashboardCards = ({
  viewAll,
  setValue,
  setInnerValue,
}: {
  setValue: any;
  setInnerValue: any;
  viewAll: (index: number) => void;
}) => {
  const contrast = General?.contrast;
  //TODO: set unfavourite API

  const navigate = useNavigate();
  // const arr: any = User?.favourites?.map((ele) => console.log(toJS(ele)));
  const renderFavourites = () => {
    const arr: any = User?.favourites?.map((element) => (
      <MyFavoritesCard
        onClick={() => {
          if (
            element?.serviceGuidePageLink === "complaint" ||
            element?.serviceGuidePageLink === "complaints"
          ) {
            navigate("/complaint");
          }
          if (element?.serviceGuidePageLink === "movein") {
            navigate(`/movein-registration`);
          } else if (element?.serviceGuidePageLink === "moveout") {
            navigate(`/moveout-termination`);
          } else if (element?.serviceGuidePageLink === "refund") {
            navigate(`/refund`);
          } else if (element?.serviceGuidePageLink === "applyforwwpr") {
            window.open(`${constants.URL.CUSTOMER_PORTAL}`);
          } else if (element?.serviceGuidePageLink === "paymentfacilities") {
            navigate(`/payment-plan`);
          } else if (element?.serviceGuidePageLink === "billenquiry") {
            setValue(1);
          } else if (element?.serviceGuidePageLink === "billpayment") {
            setValue(1);
            setInnerValue(1);
          } else if (element?.serviceGuidePageLink === "Suggestionscomplaint") {
            navigate(`/complaint`);
          } else if (element?.serviceGuidePageLink === "sccd") {
            navigate(`/social-case-consideration`);
          } else if (
            element?.serviceGuidePageLink === "tenantnoc" ||
            element?.serviceGuidePageLink === "ownernoc"
          ) {
            navigate(`/noc-apply`, { state: { login: false } });
          }
        }}
        style={{
          cursor: "pointer",
          backgroundColor: contrast?.contrastBackground
            ? contrast?.contrastBackground
            : "rgba(229, 239, 242, 0.7)",
          color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
        }}
      >
        <>
          {element.serviceGuideTitle}
          <div style={{ cursor: "pointer" }}>
            {element?.isFavorite ? (
              <StarOutlinedIcon
              style={{
                fill: contrast?.contrastColor ? contrast?.contrastColor : ColorAss === "#101E8E" ? "#62AA51" : ColorAss,
                cursor: "pointer"
              }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleRemoveFavourite(element?.serviceGuideId as string);
                }}
              />
            ) : (
              <StarBorderOutlined style={{
                fill: contrast?.contrastBackground ? contrast?.contrastBackground : ColorAss === "#101E8E" ? "#62AA51" : ColorAss,
                cursor: "pointer"
              }} />
            )}
          </div>
        </>
      </MyFavoritesCard>
    ));
    return arr;
  };

  const favObjectGen = () => {
    const favs = User.favourites;
    let favObj: Obj = {};

    for (let index = 0; index < favs.length; index++) {
      const fav = favs[index];
      favObj[favs[index].serviceGuideId as string] = true;
    }

    return favObj;
  };

  const favourites = favObjectGen();

  const handleRemoveFavourite = async (serviceId: string) => {
    await User.removeFavourite(serviceId);
  };

  const ColorAss = General?.ColorAss;

  React.useEffect(() => {
    General.fetchDashboardWidgets({ errorId: "fetchDashboardWidgetsError" });

    PaymentReceipts.getPendingPayments({
      errorId: "getPendingPaymentsError",
      data: {
        personId: User.info.personId as string,
        fullName: User.info.userName as string,
      },
    });

    General.getDashRecentRequests({
      errorId: "getDashRecentRequestsError",
      data: User.info.personId,
    });
    General.getDashCommonlyUsedServices({
      errorId: "getDashCommonlyUsedServicesError",
      data: User.info.personId,
    });
  }, []);

  const [isLargeScreen, setIsLargeScreen] = React.useState(false);

  React.useEffect(() => {
    function handleResize() {
      setIsLargeScreen(window.innerWidth > 991);
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);



  interface DataItem {
    num: any;
    textbeforenumber1: any;
    textbeforenumber2: any;
    text: any;
    testbefore1: any;
    testafter1: any;

    testbefore2: any;
    testafter2: any;
    isOverdue2?: boolean;
    commonText0: any;
    commonText: any;
    enable: any;

    image: any;
  }

  const data1: any[] = [
    {
      stateTab: 1,
      stateInnerTab: null,
      num: new Intl.NumberFormat('en', { minimumFractionDigits: 2 }).format(
        Number(
          General.dashboard?.cmCSSPendingPaymentsWidgetOutput
            ?.totalNumberOfPendingPayments
        ))
      ,
      text: General?.codeLabels["cm_pdc_status_payment_pending"]?.label
        ? General?.codeLabels["cm_pdc_status_payment_pending"]?.label
        : "PENDING PAYMENTS",

      testbefore1: General?.codeLabels["cm_mob_aed"]?.label
        ? General?.codeLabels["cm_mob_aed"]?.label
        : "AED",
      textbeforenumber1: new Intl.NumberFormat('en', { minimumFractionDigits: 2 }).format(
        Number(
          General.dashboard?.cmCSSPendingPaymentsWidgetOutput
            ?.totalAmountPending
        )),
      testafter1: General?.codeLabels["cm_pending_oi"]?.label
        ? General?.codeLabels["cm_pending_oi"]?.label
        : "Pending",

      testbefore2: General?.codeLabels["cm_mob_aed"]?.label
        ? General?.codeLabels["cm_mob_aed"]?.label
        : "AED",
      textbeforenumber2: new Intl.NumberFormat('en', { minimumFractionDigits: 2 }).format(
        Number(
          General.dashboard?.cmCSSPendingPaymentsWidgetOutput
            ?.totalOverdueAmount
        )),
      testafter2: General?.codeLabels["cm_overdue-oi"]?.label
        ? General?.codeLabels["cm_overdue-oi"]?.label
        : "OVERDUE",
      isOverdue2: true,

      commonText0: "",
      commonText: "",
      image: <svg
        width="27" height="21" viewBox="0 0 27 21"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.40039 0.399902C1.30039 0.399902 0.400391 1.2999 0.400391 2.3999V17.5999C0.400391 18.6999 1.30039 19.5999 2.40039 19.5999H7.19414C8.53008 21.9843 11.077 23.5999 14.0004 23.5999C16.9238 23.5999 19.4707 21.9843 20.8066 19.5999H25.6004C26.7004 19.5999 27.6004 18.6999 27.6004 17.5999V2.3999C27.6004 1.2999 26.7004 0.399902 25.6004 0.399902H2.40039ZM2.40039 1.1999H25.6004C26.2676 1.1999 26.8004 1.73271 26.8004 2.3999V4.3999H1.20039V2.3999C1.20039 1.73271 1.7332 1.1999 2.40039 1.1999ZM1.20039 5.9999H26.8004V17.5999C26.8004 18.2671 26.2676 18.7999 25.6004 18.7999H21.2004C21.5863 17.8765 21.8004 16.8624 21.8004 15.7999C21.8004 11.4968 18.3035 7.9999 14.0004 7.9999C9.69727 7.9999 6.20039 11.4968 6.20039 15.7999C6.20039 16.8624 6.41445 17.8765 6.80039 18.7999H2.40039C1.7332 18.7999 1.20039 18.2671 1.20039 17.5999V5.9999ZM2.80039 7.9999C2.58008 7.9999 2.40039 8.17959 2.40039 8.3999C2.40039 8.62021 2.58008 8.7999 2.80039 8.7999C3.0207 8.7999 3.20039 8.62021 3.20039 8.3999C3.20039 8.17959 3.0207 7.9999 2.80039 7.9999ZM4.40039 7.9999C4.18008 7.9999 4.00039 8.17959 4.00039 8.3999C4.00039 8.62021 4.18008 8.7999 4.40039 8.7999C4.6207 8.7999 4.80039 8.62021 4.80039 8.3999C4.80039 8.17959 4.6207 7.9999 4.40039 7.9999ZM6.00039 7.9999C5.78008 7.9999 5.60039 8.17959 5.60039 8.3999C5.60039 8.62021 5.78008 8.7999 6.00039 8.7999C6.2207 8.7999 6.40039 8.62021 6.40039 8.3999C6.40039 8.17959 6.2207 7.9999 6.00039 7.9999ZM7.60039 7.9999C7.38008 7.9999 7.20039 8.17959 7.20039 8.3999C7.20039 8.62021 7.38008 8.7999 7.60039 8.7999C7.8207 8.7999 8.00039 8.62021 8.00039 8.3999C8.00039 8.17959 7.8207 7.9999 7.60039 7.9999ZM14.0004 8.7999C16.1488 8.7999 18.0676 9.76709 19.3504 11.2874C19.2566 11.364 19.2004 11.478 19.2004 11.5999C19.2004 11.8202 19.3801 11.9999 19.6004 11.9999C19.6832 11.9999 19.7645 11.9749 19.8316 11.9265C20.5691 13.0358 21.0004 14.3655 21.0004 15.7999C21.0004 17.3796 20.4738 18.8312 19.5941 19.9999C19.3754 20.0046 19.2004 20.1827 19.2004 20.3999C19.2004 20.4233 19.202 20.4468 19.2066 20.4702C17.9254 21.8983 16.0723 22.7999 14.0004 22.7999C10.1301 22.7999 7.00039 19.6702 7.00039 15.7999C7.00039 11.9296 10.1301 8.7999 14.0004 8.7999ZM10.0004 11.1999C9.78008 11.1999 9.60039 11.3796 9.60039 11.5999C9.60039 11.8202 9.78008 11.9999 10.0004 11.9999C10.2207 11.9999 10.4004 11.8202 10.4004 11.5999C10.4004 11.3796 10.2207 11.1999 10.0004 11.1999ZM11.6004 11.1999C11.3801 11.1999 11.2004 11.3796 11.2004 11.5999C11.2004 11.8202 11.3801 11.9999 11.6004 11.9999C11.8207 11.9999 12.0004 11.8202 12.0004 11.5999C12.0004 11.3796 11.8207 11.1999 11.6004 11.1999ZM13.2004 11.1999C12.9801 11.1999 12.8004 11.3796 12.8004 11.5999C12.8004 11.8202 12.9801 11.9999 13.2004 11.9999C13.4207 11.9999 13.6004 11.8202 13.6004 11.5999C13.6004 11.3796 13.4207 11.1999 13.2004 11.1999ZM14.8004 11.1999C14.5801 11.1999 14.4004 11.3796 14.4004 11.5999C14.4004 11.8202 14.5801 11.9999 14.8004 11.9999C15.0207 11.9999 15.2004 11.8202 15.2004 11.5999C15.2004 11.3796 15.0207 11.1999 14.8004 11.1999ZM16.4004 11.1999C16.1801 11.1999 16.0004 11.3796 16.0004 11.5999C16.0004 11.8202 16.1801 11.9999 16.4004 11.9999C16.6207 11.9999 16.8004 11.8202 16.8004 11.5999C16.8004 11.3796 16.6207 11.1999 16.4004 11.1999ZM18.0004 11.1999C17.7801 11.1999 17.6004 11.3796 17.6004 11.5999C17.6004 11.8202 17.7801 11.9999 18.0004 11.9999C18.2207 11.9999 18.4004 11.8202 18.4004 11.5999C18.4004 11.3796 18.2207 11.1999 18.0004 11.1999ZM10.1238 14.2233C9.10977 14.2233 8.48789 14.8999 8.48789 16.0046C8.48789 17.1093 9.11133 17.7874 10.1238 17.7874C10.991 17.7874 11.6191 17.2421 11.6473 16.4687H10.8238C10.7738 16.8312 10.4973 17.0702 10.127 17.0702C9.65352 17.0702 9.36445 16.6624 9.36445 16.0015C9.36445 15.3437 9.65351 14.9405 10.1254 14.9405C10.4941 14.9405 10.7738 15.189 10.8191 15.5562H11.6441C11.6191 14.7905 10.9754 14.2233 10.1238 14.2233ZM12.2816 14.314L13.3707 17.6952H14.4582L15.5191 14.314H14.5926L13.9613 16.8046H13.9176L13.2676 14.314H12.2816ZM16.102 14.314L17.1926 17.6952H18.2801L19.341 14.314H18.4129L17.7816 16.8046H17.7379L17.0879 14.314H16.102ZM10.0004 19.9999C9.78008 19.9999 9.60039 20.1796 9.60039 20.3999C9.60039 20.6202 9.78008 20.7999 10.0004 20.7999C10.2207 20.7999 10.4004 20.6202 10.4004 20.3999C10.4004 20.1796 10.2207 19.9999 10.0004 19.9999ZM11.6004 19.9999C11.3801 19.9999 11.2004 20.1796 11.2004 20.3999C11.2004 20.6202 11.3801 20.7999 11.6004 20.7999C11.8207 20.7999 12.0004 20.6202 12.0004 20.3999C12.0004 20.1796 11.8207 19.9999 11.6004 19.9999ZM13.2004 19.9999C12.9801 19.9999 12.8004 20.1796 12.8004 20.3999C12.8004 20.6202 12.9801 20.7999 13.2004 20.7999C13.4207 20.7999 13.6004 20.6202 13.6004 20.3999C13.6004 20.1796 13.4207 19.9999 13.2004 19.9999ZM14.8004 19.9999C14.5801 19.9999 14.4004 20.1796 14.4004 20.3999C14.4004 20.6202 14.5801 20.7999 14.8004 20.7999C15.0207 20.7999 15.2004 20.6202 15.2004 20.3999C15.2004 20.1796 15.0207 19.9999 14.8004 19.9999ZM16.4004 19.9999C16.1801 19.9999 16.0004 20.1796 16.0004 20.3999C16.0004 20.6202 16.1801 20.7999 16.4004 20.7999C16.6207 20.7999 16.8004 20.6202 16.8004 20.3999C16.8004 20.1796 16.6207 19.9999 16.4004 19.9999ZM18.0004 19.9999C17.7801 19.9999 17.6004 20.1796 17.6004 20.3999C17.6004 20.6202 17.7801 20.7999 18.0004 20.7999C18.2207 20.7999 18.4004 20.6202 18.4004 20.3999C18.4004 20.1796 18.2207 19.9999 18.0004 19.9999Z"
          fill={
            General?.colorClass == "black"
              ? "black"
              : `#62AA51`
          }
        />
      </svg>,
      enable: "",
    },

    {
      stateTab: 2,
      stateInnerTab: null,
      num: new Intl.NumberFormat('en', { minimumFractionDigits: 2 }).format(
        Number(
          General.dashboard?.cmCSSOpenRequestsWidgetOutput
            ?.totalNumberOfRequests
        )
      ),
      text: General?.codeLabels["cm_my_request"]?.label
        ? General?.codeLabels["cm_my_request"]?.label
        : "MY REQUESTS",
      customerPendingCount:General?.dashboard?.cmCSSOpenRequestsWidgetOutput?.pendingCustomerActionCount ?? 0,
      testbefore1: "",
      textbeforenumber1: 0,
      testafter1: "",

      testbefore2: "",
      textbeforenumber2: 0,
      testafter2: "",

      commonText0: "",
      commonText: General?.codeLabels["cm_in_progress_request"]?.label
        ? General?.codeLabels["cm_in_progress_request"]?.label
        : " IN-PROGRESS REQUESTS",
      image: <svg
        width="17" height="20" viewBox="0 0 17 20" fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V20H16.129V0H0ZM0.645161 0.645161H15.4839V19.3548H0.645161V0.645161ZM1.93548 1.6129C1.93548 1.43523 2.08039 1.29032 2.25806 1.29032C2.43574 1.29032 2.58065 1.43523 2.58065 1.6129C2.58065 1.79057 2.43574 1.93548 2.25806 1.93548C2.08039 1.93548 1.93548 1.79057 1.93548 1.6129ZM2.25806 2.58065C2.08039 2.58065 1.93548 2.72555 1.93548 2.90323C1.93548 3.0809 2.08039 3.22581 2.25806 3.22581C2.43574 3.22581 2.58065 3.0809 2.58065 2.90323C2.58065 2.72555 2.43574 2.58065 2.25806 2.58065ZM4.51613 4.19355C4.51613 3.30645 5.24194 2.58065 6.12903 2.58065C7.01613 2.58065 7.74194 3.30645 7.74194 4.19355C7.74194 4.68372 7.51512 5.11971 7.16734 5.41709C7.89062 5.79385 8.3871 6.5499 8.3871 7.41935H7.74194C7.74194 6.5247 7.02369 5.80645 6.12903 5.80645C5.23438 5.80645 4.51613 6.5247 4.51613 7.41935H3.87097C3.87097 6.5499 4.36744 5.79385 5.09073 5.41709C4.74294 5.11971 4.51613 4.68372 4.51613 4.19355ZM13.5484 2.90323H9.67742V3.54839H13.5484V2.90323ZM7.09677 4.19355C7.09677 3.65549 6.66709 3.22581 6.12903 3.22581C5.59098 3.22581 5.16129 3.65549 5.16129 4.19355C5.16129 4.7316 5.59098 5.16129 6.12903 5.16129C6.66709 5.16129 7.09677 4.7316 7.09677 4.19355ZM2.25806 3.87097C2.08039 3.87097 1.93548 4.01588 1.93548 4.19355C1.93548 4.37122 2.08039 4.51613 2.25806 4.51613C2.43574 4.51613 2.58065 4.37122 2.58065 4.19355C2.58065 4.01588 2.43574 3.87097 2.25806 3.87097ZM13.5484 5.48387H9.67742V4.83871H13.5484V5.48387ZM2.25806 5.16129C2.08039 5.16129 1.93548 5.3062 1.93548 5.48387C1.93548 5.66154 2.08039 5.80645 2.25806 5.80645C2.43574 5.80645 2.58065 5.66154 2.58065 5.48387C2.58065 5.3062 2.43574 5.16129 2.25806 5.16129ZM1.93548 6.77419C1.93548 6.59652 2.08039 6.45161 2.25806 6.45161C2.43574 6.45161 2.58065 6.59652 2.58065 6.77419C2.58065 6.95186 2.43574 7.09677 2.25806 7.09677C2.08039 7.09677 1.93548 6.95186 1.93548 6.77419ZM9.67742 7.41935H13.5484V6.77419H9.67742V7.41935ZM1.93548 8.06452C1.93548 7.88684 2.08039 7.74194 2.25806 7.74194C2.43574 7.74194 2.58065 7.88684 2.58065 8.06452C2.58065 8.24219 2.43574 8.3871 2.25806 8.3871C2.08039 8.3871 1.93548 8.24219 1.93548 8.06452ZM2.25806 9.03226C2.08039 9.03226 1.93548 9.17717 1.93548 9.35484C1.93548 9.53251 2.08039 9.67742 2.25806 9.67742C2.43574 9.67742 2.58065 9.53251 2.58065 9.35484C2.58065 9.17717 2.43574 9.03226 2.25806 9.03226ZM1.93548 10.6452C1.93548 10.4675 2.08039 10.3226 2.25806 10.3226C2.43574 10.3226 2.58065 10.4675 2.58065 10.6452C2.58065 10.8228 2.43574 10.9677 2.25806 10.9677C2.08039 10.9677 1.93548 10.8228 1.93548 10.6452ZM3.87097 10.9677H13.5484V10.3226H3.87097V10.9677ZM1.93548 11.9355C1.93548 11.7578 2.08039 11.6129 2.25806 11.6129C2.43574 11.6129 2.58065 11.7578 2.58065 11.9355C2.58065 12.1132 2.43574 12.2581 2.25806 12.2581C2.08039 12.2581 1.93548 12.1132 1.93548 11.9355ZM3.87097 12.5806V13.2258H11.6129V12.5806H3.87097ZM1.93548 13.2258C1.93548 13.0481 2.08039 12.9032 2.25806 12.9032C2.43574 12.9032 2.58065 13.0481 2.58065 13.2258C2.58065 13.4035 2.43574 13.5484 2.25806 13.5484C2.08039 13.5484 1.93548 13.4035 1.93548 13.2258ZM2.25806 14.1935C2.08039 14.1935 1.93548 14.3385 1.93548 14.5161C1.93548 14.6938 2.08039 14.8387 2.25806 14.8387C2.43574 14.8387 2.58065 14.6938 2.58065 14.5161C2.58065 14.3385 2.43574 14.1935 2.25806 14.1935ZM3.87097 15.4839V14.8387H13.5484V15.4839H3.87097ZM2.25806 15.4839C2.08039 15.4839 1.93548 15.6288 1.93548 15.8065C1.93548 15.9841 2.08039 16.129 2.25806 16.129C2.43574 16.129 2.58065 15.9841 2.58065 15.8065C2.58065 15.6288 2.43574 15.4839 2.25806 15.4839ZM1.93548 17.0968C1.93548 16.9191 2.08039 16.7742 2.25806 16.7742C2.43574 16.7742 2.58065 16.9191 2.58065 17.0968C2.58065 17.2744 2.43574 17.4194 2.25806 17.4194C2.08039 17.4194 1.93548 17.2744 1.93548 17.0968ZM3.87097 17.0968V17.7419H11.6129V17.0968H3.87097ZM1.93548 18.3871C1.93548 18.2094 2.08039 18.0645 2.25806 18.0645C2.43574 18.0645 2.58065 18.2094 2.58065 18.3871C2.58065 18.5648 2.43574 18.7097 2.25806 18.7097C2.08039 18.7097 1.93548 18.5648 1.93548 18.3871Z"
          fill={
            General?.colorClass == "black"
              ? "black"
              : `#62AA51`
          }
        />
      </svg>,
      enable: "",
    },

    {
      stateTab: 6,
      stateInnerTab: null,
      num: new Intl.NumberFormat('en', { minimumFractionDigits: 2 }).format(
        Number(
          General.dashboard?.cmCSSActiveNOCWidgetOutput?.totalNumberOfActiveNOC
        )
      ),
      text: General?.codeLabels["cm_active_nocs"]?.label
        ? General?.codeLabels["cm_active_nocs"]?.label
        : "ACTIVE NOCS",

      testbefore1: "",
      textbeforenumber1: 0,
      testafter1: "",

      testbefore2: "",
      textbeforenumber2: 0,
      testafter2: "",

      commonText0: "",
      commonText: General?.codeLabels["cm_noc_avail"]?.label
        ? General?.codeLabels["cm_noc_avail"]?.label
        : "NOCs AVAILABLE",
      image: <svg
        width="19" height="23" viewBox="0 0 19 23" fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.5 0.0419922C8.76019 0.0419922 8.01898 0.272217 7.38727 0.732666L6.41724 1.43738H1.23438C0.641968 1.43738 0.15625 1.9231 0.15625 2.5155V21.203C0.15625 21.7954 0.641968 22.2811 1.23438 22.2811H17.7656C18.358 22.2811 18.8438 21.7954 18.8438 21.203V2.5155C18.8438 1.9231 18.358 1.43738 17.7656 1.43738H12.5828L11.6127 0.732666C10.981 0.272217 10.2398 0.0433959 9.5 0.0419922ZM9.5 0.76355C10.0924 0.76355 10.6862 0.947449 11.193 1.31525L11.3615 1.43738L12.3469 2.15613L12.6487 2.37512C12.9281 2.57587 13.0938 2.90295 13.0938 3.24829V3.953C13.0938 4.15094 12.9323 4.31238 12.7344 4.31238H6.26562C6.06769 4.31238 5.90625 4.15094 5.90625 3.953V3.24829C5.90625 2.90295 6.0719 2.57587 6.35126 2.37512L6.65308 2.15613L7.63855 1.43738L7.80701 1.31525C8.31378 0.947449 8.90759 0.76355 9.5 0.76355ZM9.5 1.078C8.90479 1.078 8.42188 1.56091 8.42188 2.15613C8.42188 2.75134 8.90479 3.23425 9.5 3.23425C10.0952 3.23425 10.5781 2.75134 10.5781 2.15613C10.5781 1.56091 10.0952 1.078 9.5 1.078ZM1.23438 2.15613H5.55811C5.32086 2.46497 5.1875 2.84961 5.1875 3.24829V3.59363H3.03125C2.63538 3.59363 2.3125 3.9165 2.3125 4.31238V19.4061C2.3125 19.802 2.63538 20.1249 3.03125 20.1249H13.1555C13.4419 20.1249 13.7156 20.0126 13.9164 19.809L16.3716 17.3538C16.5752 17.153 16.6875 16.8793 16.6875 16.5929V4.31238C16.6875 3.9165 16.3646 3.59363 15.9688 3.59363H13.8125V3.24829C13.8125 2.84961 13.6791 2.46497 13.4419 2.15613H17.7656C17.9636 2.15613 18.125 2.31757 18.125 2.5155V21.203C18.125 21.4009 17.9636 21.5624 17.7656 21.5624H1.23438C1.03644 21.5624 0.875 21.4009 0.875 21.203V2.5155C0.875 2.31757 1.03644 2.15613 1.23438 2.15613ZM3.03125 4.31238H5.25208C5.39948 4.72931 5.79816 5.03113 6.26562 5.03113H12.7344C13.2018 5.03113 13.6005 4.72931 13.7479 4.31238H15.9688V16.5311H13.8125C13.4166 16.5311 13.0938 16.854 13.0938 17.2499V19.4061H3.03125V4.31238ZM4.10938 5.74988C3.91144 5.74988 3.75 5.91132 3.75 6.10925V6.828C3.75 7.02594 3.91144 7.18738 4.10938 7.18738C4.30731 7.18738 4.46875 7.02594 4.46875 6.828V6.10925C4.46875 5.91132 4.30731 5.74988 4.10938 5.74988ZM5.90625 5.74988C5.70831 5.74988 5.54688 5.91132 5.54688 6.10925V6.828C5.54688 7.02594 5.70831 7.18738 5.90625 7.18738C6.10419 7.18738 6.26562 7.02594 6.26562 6.828V6.10925C6.26562 5.91132 6.10419 5.74988 5.90625 5.74988ZM7.70312 5.74988C7.50519 5.74988 7.34375 5.91132 7.34375 6.10925V6.828C7.34375 7.02594 7.50519 7.18738 7.70312 7.18738C7.90106 7.18738 8.0625 7.02594 8.0625 6.828V6.10925C8.0625 5.91132 7.90106 5.74988 7.70312 5.74988ZM9.5 5.74988C9.30206 5.74988 9.14062 5.91132 9.14062 6.10925V6.828C9.14062 7.02594 9.30206 7.18738 9.5 7.18738C9.69794 7.18738 9.85938 7.02594 9.85938 6.828V6.10925C9.85938 5.91132 9.69794 5.74988 9.5 5.74988ZM11.2969 5.74988C11.0989 5.74988 10.9375 5.91132 10.9375 6.10925V6.828C10.9375 7.02594 11.0989 7.18738 11.2969 7.18738C11.4948 7.18738 11.6562 7.02594 11.6562 6.828V6.10925C11.6562 5.91132 11.4948 5.74988 11.2969 5.74988ZM13.0938 5.74988C12.8958 5.74988 12.7344 5.91132 12.7344 6.10925V6.828C12.7344 7.02594 12.8958 7.18738 13.0938 7.18738C13.2917 7.18738 13.4531 7.02594 13.4531 6.828V6.10925C13.4531 5.91132 13.2917 5.74988 13.0938 5.74988ZM14.8906 5.74988C14.6927 5.74988 14.5312 5.91132 14.5312 6.10925V6.828C14.5312 7.02594 14.6927 7.18738 14.8906 7.18738C15.0886 7.18738 15.25 7.02594 15.25 6.828V6.10925C15.25 5.91132 15.0886 5.74988 14.8906 5.74988ZM14.1719 9.34363C14.0806 9.34363 13.988 9.37872 13.9178 9.44891L12.7344 10.6323L12.2697 10.1677C12.1293 10.0273 11.9019 10.0273 11.7615 10.1677C11.6212 10.308 11.6212 10.5355 11.7615 10.6758L12.4803 11.3946C12.5505 11.4648 12.6417 11.4999 12.7344 11.4999C12.827 11.4999 12.9183 11.4648 12.9885 11.3946L14.426 9.95709C14.5663 9.81671 14.5663 9.58929 14.426 9.44891C14.3558 9.37872 14.2631 9.34363 14.1719 9.34363ZM5.1875 10.0624C4.98956 10.0624 4.82812 10.2238 4.82812 10.4218C4.82812 10.6197 4.98956 10.7811 5.1875 10.7811H7.34375C7.54169 10.7811 7.70312 10.6197 7.70312 10.4218C7.70312 10.2238 7.54169 10.0624 7.34375 10.0624H5.1875ZM8.78125 10.0624C8.58331 10.0624 8.42188 10.2238 8.42188 10.4218C8.42188 10.6197 8.58331 10.7811 8.78125 10.7811H10.2188C10.4167 10.7811 10.5781 10.6197 10.5781 10.4218C10.5781 10.2238 10.4167 10.0624 10.2188 10.0624H8.78125ZM14.1719 12.9374C14.0806 12.9374 13.988 12.9725 13.9178 13.0427L12.7344 14.2261L12.2697 13.7614C12.1293 13.621 11.9019 13.621 11.7615 13.7614C11.6212 13.9018 11.6212 14.1292 11.7615 14.2696L12.4803 14.9883C12.5505 15.0585 12.6417 15.0936 12.7344 15.0936C12.827 15.0936 12.9183 15.0585 12.9885 14.9883L14.426 13.5508C14.5663 13.4105 14.5663 13.183 14.426 13.0427C14.3558 12.9725 14.2631 12.9374 14.1719 12.9374ZM5.1875 13.6561C4.98956 13.6561 4.82812 13.8176 4.82812 14.0155C4.82812 14.2134 4.98956 14.3749 5.1875 14.3749H10.2188C10.4167 14.3749 10.5781 14.2134 10.5781 14.0155C10.5781 13.8176 10.4167 13.6561 10.2188 13.6561H5.1875ZM13.8125 17.2499H15.462L13.8125 18.8994V17.2499Z"
          fill={
            General?.colorClass == "black"
              ? "black"
              : `#62AA51`
          }
        />
      </svg>,
      enable: "",
    },

    {
      stateTab: 6,
      stateInnerTab: null,
      num: new Intl.NumberFormat('en', { minimumFractionDigits: 2 }).format(
        Number(
          General.dashboard?.cmCSSActiveAccountsWidgetOutput
            ?.totalNumberOfActiveAccount
        )
      ),
      text:
        General?.codeLabels["cm_myprofile"]?.label !== undefined
          ? General?.codeLabels["cm_myprofile"]?.label
          : "MY PROFILE",

      testbefore1: "",
      textbeforenumber1: 0,
      testafter1: "",

      testbefore2: "",
      textbeforenumber2: 0,
      testafter2: "",

      commonText0: General?.codeLabels["cm_active_acc"]?.label
        ? General?.codeLabels["cm_active_acc"]?.label
        : "ACTIVE ACCOUNTS",
      commonText: General?.codeLabels["cm_noresponse"]?.label
        ? General?.codeLabels["cm_noresponse"]?.label
        : "NO RESPONSE INACTIVE",
      image: <svg
        width="28" height="21" viewBox="0 0 28 21" fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.09277 0.196289C1.4043 0.196289 0.842773 0.757812 0.842773 1.44629V18.5296C0.842773 19.4492 1.58984 20.1963 2.50944 20.1963H22.7992C23.5527 20.1963 24.2152 19.6885 24.4105 18.9528L27.2409 7.58073C27.3337 7.20475 27.2507 6.81413 27.013 6.50977C26.7738 6.2054 26.4141 6.02962 26.0267 6.02962H23.3428V3.94629C23.3428 3.25781 22.7812 2.69629 22.0928 2.69629H11.554C11.222 2.69629 10.9111 2.56771 10.6751 2.33496L9.1224 0.798503C8.73014 0.409505 8.20931 0.196289 7.65755 0.196289H2.09277ZM2.09277 1.02962H7.65755C7.98958 1.02962 8.30046 1.1582 8.53646 1.39095L10.0876 2.92578C10.4814 3.31478 11.0023 3.52962 11.554 3.52962H22.0928C22.3223 3.52962 22.5094 3.7168 22.5094 3.94629V6.02962H7.72266C6.95443 6.02962 6.29036 6.55046 6.10482 7.29427L3.34766 18.4043C3.34603 18.4124 3.11816 19.363 2.50944 19.363C2.05046 19.363 1.67611 18.9886 1.67611 18.5296V1.44629C1.67611 1.2168 1.86328 1.02962 2.09277 1.02962ZM26.0267 6.86296H7.72266C7.33854 6.86296 7.00651 7.12337 6.91374 7.49609L5.00293 15.1963H19.5928C19.8239 15.1963 20.0094 15.3818 20.0094 15.613C20.0094 15.8441 19.8239 16.0296 19.5928 16.0296H4.7946L4.15983 18.5947C4.10938 18.8161 4.00846 19.0977 3.84733 19.363H22.7992C23.1768 19.363 23.5072 19.109 23.6048 18.7445L26.4303 7.37891C26.4629 7.25358 26.4352 7.125 26.3555 7.02409C26.2757 6.92155 26.1569 6.86296 26.0267 6.86296ZM21.2594 15.1963C21.0283 15.1963 20.8428 15.3818 20.8428 15.613C20.8428 15.8441 21.0283 16.0296 21.2594 16.0296H22.9261C23.1572 16.0296 23.3428 15.8441 23.3428 15.613C23.3428 15.3818 23.1572 15.1963 22.9261 15.1963H21.2594ZM5.23079 17.1787C5.27148 17.0111 5.40983 16.8923 5.56934 16.8678C5.62305 16.8581 5.68001 16.8613 5.73535 16.876C5.95833 16.9313 6.09505 17.1576 6.03809 17.3805L5.82975 18.2139C5.78255 18.4027 5.61328 18.5296 5.42611 18.5296C5.39355 18.5296 5.35938 18.5264 5.3252 18.5166C5.10221 18.4613 4.96549 18.235 5.02246 18.012L5.23079 17.1787ZM7.65267 16.8678C7.49316 16.8923 7.35482 17.0111 7.31413 17.1787L7.10579 18.012C7.04883 18.235 7.18555 18.4613 7.40853 18.5166C7.44271 18.5264 7.47689 18.5296 7.50944 18.5296C7.69661 18.5296 7.86589 18.4027 7.91309 18.2139L8.12142 17.3805C8.17839 17.1576 8.04167 16.9313 7.81869 16.876C7.76335 16.8613 7.70638 16.8581 7.65267 16.8678ZM9.39746 17.1787C9.43815 17.0111 9.5765 16.8923 9.736 16.8678C9.78971 16.8581 9.84668 16.8613 9.90202 16.876C10.125 16.9313 10.2617 17.1576 10.2048 17.3805L9.99642 18.2139C9.94922 18.4027 9.77995 18.5296 9.59277 18.5296C9.56022 18.5296 9.52604 18.5264 9.49186 18.5166C9.26888 18.4613 9.13216 18.235 9.18913 18.012L9.39746 17.1787ZM11.8193 16.8678C11.6598 16.8923 11.5215 17.0111 11.4808 17.1787L11.2725 18.012C11.2155 18.235 11.3522 18.4613 11.5752 18.5166C11.6094 18.5264 11.6436 18.5296 11.6761 18.5296C11.8633 18.5296 12.0326 18.4027 12.0798 18.2139L12.2881 17.3805C12.3451 17.1576 12.2083 16.9313 11.9854 16.876C11.93 16.8613 11.873 16.8581 11.8193 16.8678ZM13.5641 17.1787C13.6048 17.0111 13.7432 16.8923 13.9027 16.8678C13.9564 16.8581 14.0133 16.8613 14.0687 16.876C14.2917 16.9313 14.4284 17.1576 14.3714 17.3805L14.1631 18.2139C14.1159 18.4027 13.9466 18.5296 13.7594 18.5296C13.7269 18.5296 13.6927 18.5264 13.6585 18.5166C13.4355 18.4613 13.2988 18.235 13.3558 18.012L13.5641 17.1787ZM15.986 16.8678C15.8265 16.8923 15.6882 17.0111 15.6475 17.1787L15.4391 18.012C15.3822 18.235 15.5189 18.4613 15.7419 18.5166C15.776 18.5264 15.8102 18.5296 15.8428 18.5296C16.0299 18.5296 16.1992 18.4027 16.2464 18.2139L16.4548 17.3805C16.5117 17.1576 16.375 16.9313 16.152 16.876C16.0967 16.8613 16.0397 16.8581 15.986 16.8678ZM17.7308 17.1787C17.7715 17.0111 17.9098 16.8923 18.0693 16.8678C18.123 16.8581 18.18 16.8613 18.2354 16.876C18.4583 16.9313 18.5951 17.1576 18.5381 17.3805L18.3298 18.2139C18.2826 18.4027 18.1133 18.5296 17.9261 18.5296C17.8936 18.5296 17.8594 18.5264 17.8252 18.5166C17.6022 18.4613 17.4655 18.235 17.5225 18.012L17.7308 17.1787ZM20.1527 16.8678C19.9915 16.8923 19.8548 17.0111 19.8141 17.1787L19.6058 18.012C19.5488 18.235 19.6855 18.4613 19.9085 18.5166C19.9427 18.5264 19.9769 18.5296 20.0094 18.5296C20.1966 18.5296 20.3659 18.4027 20.4131 18.2139L20.6214 17.3805C20.6784 17.1576 20.5417 16.9313 20.3187 16.876C20.2633 16.8613 20.2064 16.8581 20.1527 16.8678ZM21.8975 17.1787C21.9382 17.0111 22.0765 16.8923 22.236 16.8678C22.2897 16.8581 22.3467 16.8613 22.402 16.876C22.625 16.9313 22.7617 17.1576 22.7048 17.3805L22.4964 18.2139C22.4492 18.4027 22.2799 18.5296 22.0928 18.5296C22.0602 18.5296 22.026 18.5264 21.9919 18.5166C21.7689 18.4613 21.6322 18.235 21.6891 18.012L21.8975 17.1787Z"
          fill={
            General?.colorClass == "black"
              ? "black"
              : `#62AA51`
          }
        />
      </svg>,
      enable: "",
    },

    {
      stateTab: 1,
      stateInnerTab: 1,
      num: new Intl.NumberFormat('en', { minimumFractionDigits: 2 }).format(
        Number(
          General.dashboard?.cmCSSBillsWidgetOutput?.totalNumberOfBills
        )
      ),
      text: General?.codeLabels["cm_my_bills"]?.label
        ? General?.codeLabels["cm_my_bills"]?.label
        : "MY BILLS",

      testbefore1: "",
      textbeforenumber1: 0,
      testafter1: "",

      testbefore2: "",
      textbeforenumber2: 0,
      testafter2: "",

      commonText0: "",
      commonText: General?.codeLabels["cm_bills_available"]?.label
        ? General?.codeLabels["cm_bills_available"]?.label
        : "BILLS AVAILABLE",
      image: <svg
        width="18" height="20" viewBox="0 0 18 20" fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.086 0.000471055C15.9972 -0.0041207 15.9099 0.024962 15.8319 0.0831282L14.4986 1.10256L13.1654 0.122926C13.0093 0.0050632 12.8532 0.0050632 12.697 0.122926L11.3638 1.10256L10.0306 0.122926C9.87444 0.0050632 9.71831 0.0050632 9.56218 0.122926L8.22896 1.10256L6.89573 0.122926C6.7396 0.0050632 6.58347 0.0050632 6.42734 0.122926L5.09411 1.10256L3.76089 0.122926C3.60476 0.0050632 3.44863 0.0050632 3.2925 0.122926L1.95928 1.10256L0.626049 0.122926C0.509718 0.0448612 0.352057 0.0050632 0.234194 0.0831282C0.078065 0.122926 0 0.240789 0 0.396918V18.8141C0 18.932 0.039798 19.01 0.117863 19.0881L0.901573 19.8718C0.979638 19.9499 1.0577 19.9897 1.17557 19.9897C1.25363 19.9897 1.33169 19.9514 1.40976 19.9116L2.74299 18.932L4.07621 19.9116C4.23234 20.0295 4.38847 20.0295 4.5446 19.9116L5.87782 18.932L7.21105 19.9116C7.36718 20.0295 7.52331 20.0295 7.67944 19.9116L9.01266 18.932L10.3459 19.9116C10.502 20.0295 10.6581 20.0295 10.8143 19.9116L12.1475 18.932L13.4807 19.9116C13.6369 20.0295 13.793 20.0295 13.9491 19.9116L15.2823 18.932L16.6156 19.9116C16.7319 19.9897 16.8896 20.0295 17.0074 19.9514C17.1238 19.8718 17.2416 19.7539 17.2416 19.5978V1.18063C17.2416 1.06277 17.2018 0.984701 17.1238 0.906636L16.34 0.122926C16.262 0.0448612 16.1747 0.0050632 16.086 0.000471055ZM3.5267 0.866838L4.85992 1.84648C5.01605 1.96434 5.17218 1.96434 5.32831 1.84648L6.66153 0.866838L7.99476 1.84648C8.15089 1.96434 8.30702 1.96434 8.46315 1.84648L9.79638 0.866838L11.1296 1.84648C11.2857 1.96434 11.4419 1.96434 11.598 1.84648L12.9312 0.866838L14.2644 1.84648C14.4206 1.96434 14.5767 1.96434 14.7328 1.84648L16.0278 0.866838L16.4579 1.33676V14.8956C16.2222 14.8956 16.0661 15.0517 16.0661 15.2874V16.0711C16.0661 16.3068 16.2222 16.463 16.4579 16.463V18.8141L15.5165 18.1085C15.3604 17.9906 15.2043 17.9906 15.0482 18.1085L13.7149 19.1279L12.3817 18.1483C12.3036 18.0702 12.2256 18.0304 12.1475 18.0304C12.0694 18.0304 11.9914 18.0687 11.9133 18.1085L10.5801 19.1279L9.24686 18.1483C9.09073 18.0304 8.9346 18.0304 8.77847 18.1483L7.44524 19.1279L6.11202 18.1483C5.95589 18.0304 5.79976 18.0304 5.64363 18.1483L4.3104 19.1279L2.97718 18.1483C2.82105 18.0304 2.66492 18.0304 2.50879 18.1483L1.21383 19.1279L0.78371 18.6564V16.463C1.01944 16.463 1.17557 16.3068 1.17557 16.0711V15.2874C1.17557 15.0517 1.01944 14.8956 0.78371 14.8956V1.18063L1.72508 1.88627C1.88121 2.00414 2.03734 2.00414 2.19347 1.88627L3.5267 0.866838ZM3.13484 4.31547C3.13484 4.07974 3.29097 3.92361 3.5267 3.92361H9.79638C10.0321 3.92361 10.1882 4.07974 10.1882 4.31547C10.1882 4.55119 10.0321 4.70732 9.79638 4.70732H3.5267C3.29097 4.70732 3.13484 4.55119 3.13484 4.31547ZM11.3638 3.92361C11.1281 3.92361 10.9719 4.07974 10.9719 4.31547C10.9719 4.55119 11.1281 4.70732 11.3638 4.70732H13.7149C13.9507 4.70732 14.1068 4.55119 14.1068 4.31547C14.1068 4.07974 13.9507 3.92361 13.7149 3.92361H11.3638ZM3.13484 5.88289C3.13484 5.64716 3.29097 5.49103 3.5267 5.49103H7.8371C8.07283 5.49103 8.22895 5.64716 8.22895 5.88289C8.22895 6.11861 8.07283 6.27474 7.8371 6.27474H3.5267C3.29097 6.27474 3.13484 6.11861 3.13484 5.88289ZM12.5394 5.49103C12.3036 5.49103 12.1475 5.64716 12.1475 5.88289V6.27474C11.4817 6.27474 10.9719 6.78446 10.9719 7.45031V8.62587C10.9719 9.29172 11.4817 9.80144 12.1475 9.80144H12.9312C13.1669 9.80144 13.3231 9.95757 13.3231 10.1933V11.3689C13.3231 11.6046 13.1669 11.7607 12.9312 11.7607H12.1475C11.9118 11.7607 11.7556 11.6046 11.7556 11.3689V10.977C11.7556 10.7413 11.5995 10.5851 11.3638 10.5851C11.1281 10.5851 10.9719 10.7413 10.9719 10.977V11.3689C10.9719 12.0347 11.4817 12.5444 12.1475 12.5444V12.9363C12.1475 13.172 12.3036 13.3281 12.5394 13.3281C12.7751 13.3281 12.9312 13.172 12.9312 12.9363V12.5444C13.5971 12.5444 14.1068 12.0347 14.1068 11.3689V10.1933C14.1068 9.52745 13.5971 9.01773 12.9312 9.01773H12.1475C11.9118 9.01773 11.7556 8.8616 11.7556 8.62587V7.45031C11.7556 7.21458 11.9118 7.05845 12.1475 7.05845H12.9312C13.1669 7.05845 13.3231 7.21458 13.3231 7.45031V7.84216C13.3231 8.07789 13.4792 8.23402 13.7149 8.23402C13.9507 8.23402 14.1068 8.07789 14.1068 7.84216V7.45031C14.1068 6.78446 13.5971 6.27474 12.9312 6.27474V5.88289C12.9312 5.64716 12.7751 5.49103 12.5394 5.49103ZM3.13484 9.01773C3.13484 8.782 3.29097 8.62587 3.5267 8.62587H7.44524C7.68097 8.62587 7.8371 8.782 7.8371 9.01773C7.8371 9.25345 7.68097 9.40958 7.44524 9.40958H3.5267C3.29097 9.40958 3.13484 9.25345 3.13484 9.01773ZM3.5267 10.1933C3.29097 10.1933 3.13484 10.3494 3.13484 10.5851C3.13484 10.8209 3.29097 10.977 3.5267 10.977H8.62081C8.85654 10.977 9.01266 10.8209 9.01266 10.5851C9.01266 10.3494 8.85654 10.1933 8.62081 10.1933H3.5267ZM3.13484 12.1526C3.13484 11.9168 3.29097 11.7607 3.5267 11.7607H5.09412C5.32984 11.7607 5.48597 11.9168 5.48597 12.1526C5.48597 12.3883 5.32984 12.5444 5.09412 12.5444H3.5267C3.29097 12.5444 3.13484 12.3883 3.13484 12.1526ZM6.66154 11.7607C6.42581 11.7607 6.26968 11.9168 6.26968 12.1526C6.26968 12.3883 6.42581 12.5444 6.66154 12.5444H7.44524C7.68097 12.5444 7.8371 12.3883 7.8371 12.1526C7.8371 11.9168 7.68097 11.7607 7.44524 11.7607H6.66154ZM2.35113 15.2874C2.35113 15.0517 2.50726 14.8956 2.74299 14.8956C2.97871 14.8956 3.13484 15.0517 3.13484 15.2874V16.0711C3.13484 16.3068 2.97871 16.463 2.74299 16.463C2.50726 16.463 2.35113 16.3068 2.35113 16.0711V15.2874ZM4.70226 14.8956C4.46653 14.8956 4.3104 15.0517 4.3104 15.2874V16.0711C4.3104 16.3068 4.46653 16.463 4.70226 16.463C4.93799 16.463 5.09411 16.3068 5.09411 16.0711V15.2874C5.09411 15.0517 4.93799 14.8956 4.70226 14.8956ZM6.26968 15.2874C6.26968 15.0517 6.42581 14.8956 6.66154 14.8956C6.89726 14.8956 7.05339 15.0517 7.05339 15.2874V16.0711C7.05339 16.3068 6.89726 16.463 6.66154 16.463C6.42581 16.463 6.26968 16.3068 6.26968 16.0711V15.2874ZM8.62081 14.8956C8.38509 14.8956 8.22896 15.0517 8.22896 15.2874V16.0711C8.22896 16.3068 8.38509 16.463 8.62081 16.463C8.85654 16.463 9.01266 16.3068 9.01266 16.0711V15.2874C9.01266 15.0517 8.85654 14.8956 8.62081 14.8956ZM10.1882 15.2874C10.1882 15.0517 10.3444 14.8956 10.5801 14.8956C10.8158 14.8956 10.9719 15.0517 10.9719 15.2874V16.0711C10.9719 16.3068 10.8158 16.463 10.5801 16.463C10.3444 16.463 10.1882 16.3068 10.1882 16.0711V15.2874ZM12.5394 14.8956C12.3036 14.8956 12.1475 15.0517 12.1475 15.2874V16.0711C12.1475 16.3068 12.3036 16.463 12.5394 16.463C12.7751 16.463 12.9312 16.3068 12.9312 16.0711V15.2874C12.9312 15.0517 12.7751 14.8956 12.5394 14.8956ZM14.1068 15.2874C14.1068 15.0517 14.2629 14.8956 14.4986 14.8956C14.7344 14.8956 14.8905 15.0517 14.8905 15.2874V16.0711C14.8905 16.3068 14.7344 16.463 14.4986 16.463C14.2629 16.463 14.1068 16.3068 14.1068 16.0711V15.2874Z"
          fill={
            General?.colorClass == "black"
              ? "black"
              : `#62AA51`
          }
        />
      </svg>,
      enable: "",
    },

    {
      stateTab: 7,
      stateInnerTab: null,
      num: new Intl.NumberFormat('en', { minimumFractionDigits: 2 }).format(
        Number(
          General.dashboard?.cmCSSAccountsAutopayWidgetOutput
            ?.totalNumberOfAcctWithApay
        )
      ),
      text: General?.codeLabels["cm_autostatus"]?.label
        ? General?.codeLabels["cm_autostatus"]?.label
        : "AUTO PAYMENT STATUS",

      testbefore1: "",
      textbeforenumber1: new Intl.NumberFormat('en', { minimumFractionDigits: 2 }).format(
        Number(
          General.dashboard?.cmCSSAccountsAutopayWidgetOutput
            ?.totalNumberOfSavedCards
        )
      ),
      testafter1:
        General?.codeLabels["cm_saved_cards"]?.label !== undefined
          ? General?.codeLabels["cm_saved_cards"]?.label
          : "SAVED CARDS",

      testbefore2: "",
      textbeforenumber2: 0,
      testafter2: "",

      commonText0: "",
      commonText: "",
      image: <svg
        width="32" height="20" viewBox="0 0 32 20" fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.35619 0.876736C9.76417 0.348958 10.3961 0 11.1114 0H29.7781C31.0003 0 32.0003 1 32.0003 2.22222V12.8889C32.0003 14.1111 31.0003 15.1111 29.7781 15.1111H23.5645L23.0958 16.7865L23.0923 16.7934C22.8961 17.4497 22.5801 18.0208 22.1305 18.4392C21.6808 18.8576 21.0888 19.1111 20.4291 19.1111C19.6045 19.1111 19.0506 18.7986 18.7173 18.4583C18.682 18.534 18.6531 18.6093 18.6245 18.684C18.5632 18.8441 18.503 19.0012 18.3822 19.1528C18.009 19.6198 17.4222 20 16.667 20C15.686 20 14.8458 19.4062 14.4586 18.5677C14.443 18.5851 14.4378 18.5938 14.4326 18.6024C14.4274 18.6111 14.4222 18.6198 14.4065 18.6372C14.0055 19.066 13.4274 19.5556 12.667 19.5556C11.8926 19.5556 11.2017 19.191 10.7538 18.6267C9.41174 19.4878 7.84751 19.9514 6.24334 19.9514H0.889173C0.729451 19.9531 0.580146 19.8698 0.498548 19.7309C0.418687 19.592 0.418687 19.4219 0.498548 19.283C0.580146 19.1441 0.729451 19.0608 0.889173 19.0625H6.24334C7.89091 19.0625 9.4916 18.5174 10.7972 17.5122L18.101 11.8837L18.3475 12.2049C18.2156 12.0122 18.2538 11.75 18.436 11.6042C18.8475 11.276 19.1114 10.7847 19.1114 10.2222C19.1114 9.23611 18.3197 8.44444 17.3336 8.44444C17.0239 8.44444 16.6393 8.63326 16.287 8.80623L16.287 8.80624L16.2069 8.84549C16.035 8.92708 15.8319 8.8941 15.6965 8.75868L15.917 8.97917L8.06278 12.6858C7.91869 12.7569 7.74681 12.7448 7.61313 12.6545C7.48119 12.5625 7.40827 12.408 7.42216 12.2483C7.43605 12.0885 7.53674 11.9479 7.68258 11.8819L8.88917 11.3125V2.22222C8.88917 2.03472 8.91869 1.85764 8.96383 1.68229C8.3232 1.34722 7.79195 1.25521 7.18431 1.39757C6.50202 1.56076 5.68778 2.04861 4.63223 2.92361C3.38917 3.95312 0.729451 6.17188 0.729451 6.17188C0.540215 6.32986 0.260701 6.30382 0.102715 6.11458C-0.0535351 5.92708 -0.0292294 5.64583 0.160007 5.48785C0.160007 5.48785 2.81799 3.27083 4.06452 2.23785C5.16522 1.32639 6.07147 0.748264 6.97945 0.534722C7.43431 0.427084 7.88223 0.421875 8.32667 0.50868C8.67042 0.576389 9.01417 0.703125 9.35619 0.876736ZM29.7781 0.888889H11.1114C10.3701 0.888889 9.77806 1.4809 9.77806 2.22222V3.11111H31.1114V2.22222C31.1114 1.4809 30.5194 0.888889 29.7781 0.888889ZM9.77806 4.88889H31.1114V12.8889C31.1114 13.6302 30.5194 14.2222 29.7781 14.2222H16.5229L18.9951 12.3177C19.0628 12.2656 19.1149 12.1944 19.1426 12.1128C19.6479 11.6302 20.0003 10.9792 20.0003 10.2222C20.0003 8.75521 18.8006 7.55556 17.3336 7.55556C16.7698 7.55556 16.3028 7.79643 15.9794 7.9633L15.9793 7.9633C15.9303 7.9886 15.8846 8.01219 15.8423 8.03299C15.8354 8.03646 15.8284 8.03993 15.8215 8.04167L9.77806 10.8941V4.88889ZM11.5558 6.22222C11.5558 5.97743 11.7555 5.77778 12.0003 5.77778C12.2451 5.77778 12.4447 5.97743 12.4447 6.22222C12.4447 6.46701 12.2451 6.66667 12.0003 6.66667C11.7555 6.66667 11.5558 6.46701 11.5558 6.22222ZM13.7781 5.77778C13.5333 5.77778 13.3336 5.97743 13.3336 6.22222C13.3336 6.46701 13.5333 6.66667 13.7781 6.66667C14.0229 6.66667 14.2225 6.46701 14.2225 6.22222C14.2225 5.97743 14.0229 5.77778 13.7781 5.77778ZM15.1114 6.22222C15.1114 5.97743 15.311 5.77778 15.5558 5.77778C15.8006 5.77778 16.0003 5.97743 16.0003 6.22222C16.0003 6.46701 15.8006 6.66667 15.5558 6.66667C15.311 6.66667 15.1114 6.46701 15.1114 6.22222ZM17.3336 5.77778C17.0888 5.77778 16.8892 5.97743 16.8892 6.22222C16.8892 6.46701 17.0888 6.66667 17.3336 6.66667C17.5784 6.66667 17.7781 6.46701 17.7781 6.22222C17.7781 5.97743 17.5784 5.77778 17.3336 5.77778ZM15.5558 10.2222C15.5558 9.97743 15.7555 9.77778 16.0003 9.77778C16.2451 9.77778 16.4447 9.97743 16.4447 10.2222C16.4447 10.467 16.2451 10.6667 16.0003 10.6667C15.7555 10.6667 15.5558 10.467 15.5558 10.2222ZM16.8892 11.1111C16.6444 11.1111 16.4447 11.3108 16.4447 11.5556C16.4447 11.8003 16.6444 12 16.8892 12C17.134 12 17.3336 11.8003 17.3336 11.5556C17.3336 11.3108 17.134 11.1111 16.8892 11.1111ZM22.6409 15.1111H15.3683L11.4777 18.1094C11.7624 18.4497 12.186 18.6667 12.667 18.6667C13.0107 18.6667 13.4326 18.3785 13.7555 18.0295C14.0784 17.6823 14.2815 17.3333 14.2815 17.3333L15.1114 17.5556C15.1114 18.4201 15.8024 19.1111 16.667 19.1111C17.1461 19.1111 17.4326 18.9167 17.6878 18.5972C17.943 18.2778 18.1218 17.8281 18.2416 17.4306L19.101 17.4601C19.101 17.4601 19.1322 17.6181 19.3076 17.8125C19.4829 18.0087 19.7781 18.2222 20.4291 18.2222C20.8735 18.2222 21.2208 18.0729 21.5246 17.7899C21.8284 17.5069 22.0801 17.0781 22.2416 16.5417L22.6409 15.1111ZM15.1114 15.5556C14.8666 15.5556 14.667 15.7552 14.667 16C14.667 16.2448 14.8666 16.4444 15.1114 16.4444C15.3562 16.4444 15.5558 16.2448 15.5558 16C15.5558 15.7552 15.3562 15.5556 15.1114 15.5556ZM18.667 16C18.667 15.7552 18.8666 15.5556 19.1114 15.5556C19.3562 15.5556 19.5558 15.7552 19.5558 16C19.5558 16.2448 19.3562 16.4444 19.1114 16.4444C18.8666 16.4444 18.667 16.2448 18.667 16Z"
          fill={
            General?.colorClass == "black"
              ? "black"
              : `#62AA51`
          }
        />
      </svg>,
      enable: General?.codeLabels["cm_dash_enabled"]?.label
        ? General?.codeLabels["cm_dash_enabled"]?.label
        : "ENABLED",
    },
  ];

  interface DataItem1 {
    color: number;
    text: string;
  }

  const data2: DataItem1[] = [
    {
      color: 0,
      text: General?.codeLabels["cm_dashboard_pay"]?.label
        ? General?.codeLabels["cm_dashboard_pay"]?.label
        : "PAY BILL",
    },
    {
      color: 0,
      text: General?.codeLabels["cm_registration_movein"]?.label
        ? General?.codeLabels["cm_registration_movein"]?.label
        : "Move In (Tenancy Registration)",
    },
    {
      color: 0,
      text: General?.codeLabels["cm_service_moveout"]?.label
        ? General?.codeLabels["cm_service_moveout"]?.label
        : "Move Out (Service Termination)",
    },
    {
      color: 0,
      text: General?.codeLabels["cm_service_noc"]?.label
        ? General?.codeLabels["cm_service_noc"]?.label
        : "Apply for NOC (For Tenants)",
    },
    {
      color: 0,
      text: General?.codeLabels["cm_service_refund"]?.label
        ? General?.codeLabels["cm_service_refund"]?.label
        : "Request for Refund",
    },
  ];

  const data3: DataItem1[] = [
    {
      color: 0,
      text: General?.codeLabels["cm_service_paymntplan"]?.label
        ? General?.codeLabels["cm_service_paymntplan"]?.label
        : "Request for Payment Plan Facility",
    },
    {
      color: 0,
      text: General?.codeLabels["cm_registration_movein"]?.label
        ? General?.codeLabels["cm_registration_movein"]?.label
        : "Move In (Tenancy Registration)",
    },
    {
      color: 0,
      text: General?.codeLabels["cm_billing_detail"]?.label
        ? General?.codeLabels["cm_billing_detail"]?.label
        : "Request for Billing Details / History",
    },
    {
      color: 0,
      text: General?.codeLabels["cm_apply_noc"]?.label
        ? General?.codeLabels["cm_apply_noc"]?.label
        : "Apply for NOC (For Tenants)",
    },
    {
      color: 0,
      text: General?.codeLabels["cm_ref_req"]?.label
        ? General?.codeLabels["cm_ref_req"]?.label
        : "Request for Refund",
    },
  ];


  return (
    <div style={{ marginBottom: "-40px" }}>
      <CardsContainer
        style={{
          minHeight: "0vh",
          overflowX: "hidden",
          background: contrast?.contrastBackground
            ? contrast?.contrastBackground
            : "#e7e9f8",
        }}
      >
        {isLargeScreen ? (
          <MainCardsContainer
            style={{
              width: "100%",
              padding: ".5rem 0",
              margin: "auto",
              paddingBottom: "2rem",
              backgroundColor: contrast?.contrastBackground
                ? contrast?.contrastBackground
                : "rgba(231, 233, 248, 1)",
              color: contrast?.contrastColor
                ? contrast?.contrastColor
                : ColorAss,
            }}
          >
            <div
              style={{
                width: "90%",
                margin: "auto",
                display: "flex",
                justifyContent: "space-between",
                gap: "1.75rem",
              }}
            >
              {
                <MainCards
                  style={{
                    flex: 4,
                    backgroundColor: contrast?.contrastBackground
                      ? contrast?.contrastBackground
                      : "",
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : ColorAss,
                  }}
                >
                  <h1
                    style={{
                      fontWeight: "lighter",
                      fontSize: `${2.75 * General.accessibility.fontSize}rem`,
                      marginTop: "1.5rem",
                      marginBottom: "1.5rem",
                    }}
                  >
                    {General?.codeLabels["cm_hi"]?.label
                      ? General?.codeLabels["cm_hi"]?.label
                      : "hi"}{" "}
                    {General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA" ? User?.profile?.arName?.trim()?.split(/[,\s]+/)?.slice(0, 1)?.join(' ') : User?.profile?.name?.trim()?.split(/[,\s]+/)?.slice(0, 1)?.join(' ')}
                  </h1>
                  <span
                    style={{
                      marginBottom: "1.5rem",
                      fontSize: `${General.accessibility.fontSize}rem`,
                      textAlign: "start",
                    }}
                  >
                    {General?.codeLabels["cm_ajman_welcome"]?.label
                      ? General?.codeLabels["cm_ajman_welcome"]?.label
                      : "Welcome to your Ajman Sewerage Dashboard"}
                  </span>
                  <div style={{ marginBottom: "1rem" }}>
                    <MainCard
                      style={{
                        fontSize: `${General.accessibility.fontSize}rem`,
                        padding: "1rem",
                        paddingBottom: "2rem",
                        backgroundColor: contrast?.contrastBackground
                          ? contrast?.contrastBackground
                          : "",
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : ColorAss,
                      }}
                      color={General.contrast.contrastColor ? General.contrast.contrastColor : ColorAss}
                      onClick={() => setValue(1)}
                    >
                      <MainCardTitle>
                        <span
                          style={{
                            fontFamily: "Segoe UI",
                            fontStyle: "normal",
                            fontWeight: "700",
                            fontSize: `${General.accessibility.fontSize}rem`,
                            lineHeight: "16px",
                            color: contrast?.contrastColor
                              ? contrast?.contrastColor
                              : ColorAss,
                          }}
                        >
                          {General?.codeLabels["cm_pdc_status_payment_pending"]
                            ?.label
                            ? General?.codeLabels[
                              "cm_pdc_status_payment_pending"
                            ]?.label
                            : "PENDING PAYMENTS"}
                        </span>
                        <div
                          style={{
                            backgroundColor: "rgba(98, 170, 81, 0.2)", // Background color with 50% opacity
                          }}
                        >
                          {/* <img src={CC} alt="" /> */}
                          <svg
                            width="27" height="21" viewBox="0 0 27 21"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M2.40039 0.399902C1.30039 0.399902 0.400391 1.2999 0.400391 2.3999V17.5999C0.400391 18.6999 1.30039 19.5999 2.40039 19.5999H7.19414C8.53008 21.9843 11.077 23.5999 14.0004 23.5999C16.9238 23.5999 19.4707 21.9843 20.8066 19.5999H25.6004C26.7004 19.5999 27.6004 18.6999 27.6004 17.5999V2.3999C27.6004 1.2999 26.7004 0.399902 25.6004 0.399902H2.40039ZM2.40039 1.1999H25.6004C26.2676 1.1999 26.8004 1.73271 26.8004 2.3999V4.3999H1.20039V2.3999C1.20039 1.73271 1.7332 1.1999 2.40039 1.1999ZM1.20039 5.9999H26.8004V17.5999C26.8004 18.2671 26.2676 18.7999 25.6004 18.7999H21.2004C21.5863 17.8765 21.8004 16.8624 21.8004 15.7999C21.8004 11.4968 18.3035 7.9999 14.0004 7.9999C9.69727 7.9999 6.20039 11.4968 6.20039 15.7999C6.20039 16.8624 6.41445 17.8765 6.80039 18.7999H2.40039C1.7332 18.7999 1.20039 18.2671 1.20039 17.5999V5.9999ZM2.80039 7.9999C2.58008 7.9999 2.40039 8.17959 2.40039 8.3999C2.40039 8.62021 2.58008 8.7999 2.80039 8.7999C3.0207 8.7999 3.20039 8.62021 3.20039 8.3999C3.20039 8.17959 3.0207 7.9999 2.80039 7.9999ZM4.40039 7.9999C4.18008 7.9999 4.00039 8.17959 4.00039 8.3999C4.00039 8.62021 4.18008 8.7999 4.40039 8.7999C4.6207 8.7999 4.80039 8.62021 4.80039 8.3999C4.80039 8.17959 4.6207 7.9999 4.40039 7.9999ZM6.00039 7.9999C5.78008 7.9999 5.60039 8.17959 5.60039 8.3999C5.60039 8.62021 5.78008 8.7999 6.00039 8.7999C6.2207 8.7999 6.40039 8.62021 6.40039 8.3999C6.40039 8.17959 6.2207 7.9999 6.00039 7.9999ZM7.60039 7.9999C7.38008 7.9999 7.20039 8.17959 7.20039 8.3999C7.20039 8.62021 7.38008 8.7999 7.60039 8.7999C7.8207 8.7999 8.00039 8.62021 8.00039 8.3999C8.00039 8.17959 7.8207 7.9999 7.60039 7.9999ZM14.0004 8.7999C16.1488 8.7999 18.0676 9.76709 19.3504 11.2874C19.2566 11.364 19.2004 11.478 19.2004 11.5999C19.2004 11.8202 19.3801 11.9999 19.6004 11.9999C19.6832 11.9999 19.7645 11.9749 19.8316 11.9265C20.5691 13.0358 21.0004 14.3655 21.0004 15.7999C21.0004 17.3796 20.4738 18.8312 19.5941 19.9999C19.3754 20.0046 19.2004 20.1827 19.2004 20.3999C19.2004 20.4233 19.202 20.4468 19.2066 20.4702C17.9254 21.8983 16.0723 22.7999 14.0004 22.7999C10.1301 22.7999 7.00039 19.6702 7.00039 15.7999C7.00039 11.9296 10.1301 8.7999 14.0004 8.7999ZM10.0004 11.1999C9.78008 11.1999 9.60039 11.3796 9.60039 11.5999C9.60039 11.8202 9.78008 11.9999 10.0004 11.9999C10.2207 11.9999 10.4004 11.8202 10.4004 11.5999C10.4004 11.3796 10.2207 11.1999 10.0004 11.1999ZM11.6004 11.1999C11.3801 11.1999 11.2004 11.3796 11.2004 11.5999C11.2004 11.8202 11.3801 11.9999 11.6004 11.9999C11.8207 11.9999 12.0004 11.8202 12.0004 11.5999C12.0004 11.3796 11.8207 11.1999 11.6004 11.1999ZM13.2004 11.1999C12.9801 11.1999 12.8004 11.3796 12.8004 11.5999C12.8004 11.8202 12.9801 11.9999 13.2004 11.9999C13.4207 11.9999 13.6004 11.8202 13.6004 11.5999C13.6004 11.3796 13.4207 11.1999 13.2004 11.1999ZM14.8004 11.1999C14.5801 11.1999 14.4004 11.3796 14.4004 11.5999C14.4004 11.8202 14.5801 11.9999 14.8004 11.9999C15.0207 11.9999 15.2004 11.8202 15.2004 11.5999C15.2004 11.3796 15.0207 11.1999 14.8004 11.1999ZM16.4004 11.1999C16.1801 11.1999 16.0004 11.3796 16.0004 11.5999C16.0004 11.8202 16.1801 11.9999 16.4004 11.9999C16.6207 11.9999 16.8004 11.8202 16.8004 11.5999C16.8004 11.3796 16.6207 11.1999 16.4004 11.1999ZM18.0004 11.1999C17.7801 11.1999 17.6004 11.3796 17.6004 11.5999C17.6004 11.8202 17.7801 11.9999 18.0004 11.9999C18.2207 11.9999 18.4004 11.8202 18.4004 11.5999C18.4004 11.3796 18.2207 11.1999 18.0004 11.1999ZM10.1238 14.2233C9.10977 14.2233 8.48789 14.8999 8.48789 16.0046C8.48789 17.1093 9.11133 17.7874 10.1238 17.7874C10.991 17.7874 11.6191 17.2421 11.6473 16.4687H10.8238C10.7738 16.8312 10.4973 17.0702 10.127 17.0702C9.65352 17.0702 9.36445 16.6624 9.36445 16.0015C9.36445 15.3437 9.65351 14.9405 10.1254 14.9405C10.4941 14.9405 10.7738 15.189 10.8191 15.5562H11.6441C11.6191 14.7905 10.9754 14.2233 10.1238 14.2233ZM12.2816 14.314L13.3707 17.6952H14.4582L15.5191 14.314H14.5926L13.9613 16.8046H13.9176L13.2676 14.314H12.2816ZM16.102 14.314L17.1926 17.6952H18.2801L19.341 14.314H18.4129L17.7816 16.8046H17.7379L17.0879 14.314H16.102ZM10.0004 19.9999C9.78008 19.9999 9.60039 20.1796 9.60039 20.3999C9.60039 20.6202 9.78008 20.7999 10.0004 20.7999C10.2207 20.7999 10.4004 20.6202 10.4004 20.3999C10.4004 20.1796 10.2207 19.9999 10.0004 19.9999ZM11.6004 19.9999C11.3801 19.9999 11.2004 20.1796 11.2004 20.3999C11.2004 20.6202 11.3801 20.7999 11.6004 20.7999C11.8207 20.7999 12.0004 20.6202 12.0004 20.3999C12.0004 20.1796 11.8207 19.9999 11.6004 19.9999ZM13.2004 19.9999C12.9801 19.9999 12.8004 20.1796 12.8004 20.3999C12.8004 20.6202 12.9801 20.7999 13.2004 20.7999C13.4207 20.7999 13.6004 20.6202 13.6004 20.3999C13.6004 20.1796 13.4207 19.9999 13.2004 19.9999ZM14.8004 19.9999C14.5801 19.9999 14.4004 20.1796 14.4004 20.3999C14.4004 20.6202 14.5801 20.7999 14.8004 20.7999C15.0207 20.7999 15.2004 20.6202 15.2004 20.3999C15.2004 20.1796 15.0207 19.9999 14.8004 19.9999ZM16.4004 19.9999C16.1801 19.9999 16.0004 20.1796 16.0004 20.3999C16.0004 20.6202 16.1801 20.7999 16.4004 20.7999C16.6207 20.7999 16.8004 20.6202 16.8004 20.3999C16.8004 20.1796 16.6207 19.9999 16.4004 19.9999ZM18.0004 19.9999C17.7801 19.9999 17.6004 20.1796 17.6004 20.3999C17.6004 20.6202 17.7801 20.7999 18.0004 20.7999C18.2207 20.7999 18.4004 20.6202 18.4004 20.3999C18.4004 20.1796 18.2207 19.9999 18.0004 19.9999Z"
                              fill={
                                General.contrast.contrastColor ? General.contrast.contrastColor : ColorAss
                              }
                            />
                          </svg>
                        </div>
                      </MainCardTitle>
                      <MainCardDetails>
                        <p
                          style={{
                            fontSize: `${5 * General.accessibility.fontSize
                              }rem`,
                            color: contrast?.contrastColor
                              ? contrast?.contrastColor
                              : ColorAss,
                          }}
                        >
                          {
                            General.dashboard?.cmCSSPendingPaymentsWidgetOutput
                              ?.totalNumberOfPendingPayments
                          }
                        </p>
                        <div className="details">
                          <span
                            className={`p`}
                            style={{
                              fontSize: `${General.accessibility.fontSize}rem`,
                              color: contrast?.contrastColor
                                ? contrast?.contrastColor
                                : ColorAss,
                              fontWeight: "400",
                              whiteSpace: 'nowrap'
                            }}
                          >
                            {General?.codeLabels["cm_mob_aed"]?.label
                              ? General?.codeLabels["cm_mob_aed"]?.label
                              : "AED"}{" "}
                            &nbsp;
                            {new Intl.NumberFormat('en', { minimumFractionDigits: 2 }).format(Number(General.dashboard?.cmCSSPendingPaymentsWidgetOutput?.totalAmountPending))}
                            &nbsp;
                            {General?.codeLabels["cm_pending_oi"]?.label
                              ? General?.codeLabels["cm_pending_oi"]?.label
                              : "Pending"}
                          </span>
                          <span
                            style={{
                              fontSize: `${General.accessibility.fontSize}rem`,
                              color: contrast?.contrastColor
                                ? contrast?.contrastColor
                                : "#d46b6b",
                              fontWeight: "400",
                            }}
                          >
                            {General?.codeLabels["cm_mob_aed"]?.label
                              ? General?.codeLabels["cm_mob_aed"]?.label
                              : "AED"}
                            &nbsp;
                            {new Intl.NumberFormat('en', { minimumFractionDigits: 2 }).format(Number(General.dashboard?.cmCSSPendingPaymentsWidgetOutput?.totalOverdueAmount))}{" "}
                            {General?.codeLabels["cm_overdue-oi"]?.label
                              ? General?.codeLabels["cm_overdue-oi"]?.label
                              : "OVERDUE"}
                          </span>
                        </div>
                      </MainCardDetails>
                    </MainCard>
                    <MainCard
                      style={{
                        fontSize: `${General.accessibility.fontSize}rem`,
                        padding: "1rem",
                        paddingBottom: "2rem",
                        backgroundColor: contrast?.contrastBackground
                          ? contrast?.contrastBackground
                          : "",
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : ColorAss,
                      }}
                      color={General.contrast.contrastColor ? General.contrast.contrastColor : ColorAss}
                      onClick={() => {
                        viewAll(2);
                      }}
                    >
                      <MainCardTitle>
                        <span
                          style={{
                            fontFamily: "Segoe UI",
                            fontStyle: "normal",
                            fontWeight: "700",
                            fontSize: `${General.accessibility.fontSize}rem`,
                            lineHeight: "16px",
                            color: contrast?.contrastColor
                              ? contrast?.contrastColor
                              : ColorAss,
                          }}
                        >
                          {General?.codeLabels["cm_my_request"]?.label
                            ? General?.codeLabels["cm_my_request"]?.label
                            : "MY REQUESTS"}
                        </span>
                        <div
                          style={{
                            backgroundColor: "rgba(98, 170, 81, 0.2)", // Background color with 50% opacity
                          }}
                        >
                          {/* <img src={myRequests} alt="" /> */}
                          <svg
                            width="17" height="20" viewBox="0 0 17 20" fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M0 0V20H16.129V0H0ZM0.645161 0.645161H15.4839V19.3548H0.645161V0.645161ZM1.93548 1.6129C1.93548 1.43523 2.08039 1.29032 2.25806 1.29032C2.43574 1.29032 2.58065 1.43523 2.58065 1.6129C2.58065 1.79057 2.43574 1.93548 2.25806 1.93548C2.08039 1.93548 1.93548 1.79057 1.93548 1.6129ZM2.25806 2.58065C2.08039 2.58065 1.93548 2.72555 1.93548 2.90323C1.93548 3.0809 2.08039 3.22581 2.25806 3.22581C2.43574 3.22581 2.58065 3.0809 2.58065 2.90323C2.58065 2.72555 2.43574 2.58065 2.25806 2.58065ZM4.51613 4.19355C4.51613 3.30645 5.24194 2.58065 6.12903 2.58065C7.01613 2.58065 7.74194 3.30645 7.74194 4.19355C7.74194 4.68372 7.51512 5.11971 7.16734 5.41709C7.89062 5.79385 8.3871 6.5499 8.3871 7.41935H7.74194C7.74194 6.5247 7.02369 5.80645 6.12903 5.80645C5.23438 5.80645 4.51613 6.5247 4.51613 7.41935H3.87097C3.87097 6.5499 4.36744 5.79385 5.09073 5.41709C4.74294 5.11971 4.51613 4.68372 4.51613 4.19355ZM13.5484 2.90323H9.67742V3.54839H13.5484V2.90323ZM7.09677 4.19355C7.09677 3.65549 6.66709 3.22581 6.12903 3.22581C5.59098 3.22581 5.16129 3.65549 5.16129 4.19355C5.16129 4.7316 5.59098 5.16129 6.12903 5.16129C6.66709 5.16129 7.09677 4.7316 7.09677 4.19355ZM2.25806 3.87097C2.08039 3.87097 1.93548 4.01588 1.93548 4.19355C1.93548 4.37122 2.08039 4.51613 2.25806 4.51613C2.43574 4.51613 2.58065 4.37122 2.58065 4.19355C2.58065 4.01588 2.43574 3.87097 2.25806 3.87097ZM13.5484 5.48387H9.67742V4.83871H13.5484V5.48387ZM2.25806 5.16129C2.08039 5.16129 1.93548 5.3062 1.93548 5.48387C1.93548 5.66154 2.08039 5.80645 2.25806 5.80645C2.43574 5.80645 2.58065 5.66154 2.58065 5.48387C2.58065 5.3062 2.43574 5.16129 2.25806 5.16129ZM1.93548 6.77419C1.93548 6.59652 2.08039 6.45161 2.25806 6.45161C2.43574 6.45161 2.58065 6.59652 2.58065 6.77419C2.58065 6.95186 2.43574 7.09677 2.25806 7.09677C2.08039 7.09677 1.93548 6.95186 1.93548 6.77419ZM9.67742 7.41935H13.5484V6.77419H9.67742V7.41935ZM1.93548 8.06452C1.93548 7.88684 2.08039 7.74194 2.25806 7.74194C2.43574 7.74194 2.58065 7.88684 2.58065 8.06452C2.58065 8.24219 2.43574 8.3871 2.25806 8.3871C2.08039 8.3871 1.93548 8.24219 1.93548 8.06452ZM2.25806 9.03226C2.08039 9.03226 1.93548 9.17717 1.93548 9.35484C1.93548 9.53251 2.08039 9.67742 2.25806 9.67742C2.43574 9.67742 2.58065 9.53251 2.58065 9.35484C2.58065 9.17717 2.43574 9.03226 2.25806 9.03226ZM1.93548 10.6452C1.93548 10.4675 2.08039 10.3226 2.25806 10.3226C2.43574 10.3226 2.58065 10.4675 2.58065 10.6452C2.58065 10.8228 2.43574 10.9677 2.25806 10.9677C2.08039 10.9677 1.93548 10.8228 1.93548 10.6452ZM3.87097 10.9677H13.5484V10.3226H3.87097V10.9677ZM1.93548 11.9355C1.93548 11.7578 2.08039 11.6129 2.25806 11.6129C2.43574 11.6129 2.58065 11.7578 2.58065 11.9355C2.58065 12.1132 2.43574 12.2581 2.25806 12.2581C2.08039 12.2581 1.93548 12.1132 1.93548 11.9355ZM3.87097 12.5806V13.2258H11.6129V12.5806H3.87097ZM1.93548 13.2258C1.93548 13.0481 2.08039 12.9032 2.25806 12.9032C2.43574 12.9032 2.58065 13.0481 2.58065 13.2258C2.58065 13.4035 2.43574 13.5484 2.25806 13.5484C2.08039 13.5484 1.93548 13.4035 1.93548 13.2258ZM2.25806 14.1935C2.08039 14.1935 1.93548 14.3385 1.93548 14.5161C1.93548 14.6938 2.08039 14.8387 2.25806 14.8387C2.43574 14.8387 2.58065 14.6938 2.58065 14.5161C2.58065 14.3385 2.43574 14.1935 2.25806 14.1935ZM3.87097 15.4839V14.8387H13.5484V15.4839H3.87097ZM2.25806 15.4839C2.08039 15.4839 1.93548 15.6288 1.93548 15.8065C1.93548 15.9841 2.08039 16.129 2.25806 16.129C2.43574 16.129 2.58065 15.9841 2.58065 15.8065C2.58065 15.6288 2.43574 15.4839 2.25806 15.4839ZM1.93548 17.0968C1.93548 16.9191 2.08039 16.7742 2.25806 16.7742C2.43574 16.7742 2.58065 16.9191 2.58065 17.0968C2.58065 17.2744 2.43574 17.4194 2.25806 17.4194C2.08039 17.4194 1.93548 17.2744 1.93548 17.0968ZM3.87097 17.0968V17.7419H11.6129V17.0968H3.87097ZM1.93548 18.3871C1.93548 18.2094 2.08039 18.0645 2.25806 18.0645C2.43574 18.0645 2.58065 18.2094 2.58065 18.3871C2.58065 18.5648 2.43574 18.7097 2.25806 18.7097C2.08039 18.7097 1.93548 18.5648 1.93548 18.3871Z"
                              fill={
                                General.contrast.contrastColor ? General.contrast.contrastColor : ColorAss
                              }
                            />
                          </svg>
                        </div>
                      </MainCardTitle>
                      <MainCardDetails>
                        <p
                          style={{
                            fontSize: `${5 * General.accessibility.fontSize
                              }rem`,
                          }}
                        >
                          {
                            General.dashboard?.cmCSSOpenRequestsWidgetOutput
                              ?.totalNumberOfRequests
                          }
                        </p>
                        <div className="details">
                          <span
                            className={`p`}
                            style={{
                              fontSize: `${General.accessibility.fontSize}rem`,
                              color: contrast?.contrastColor
                                ? contrast?.contrastColor
                                : ColorAss,
                                marginTop: General.dashboard?.cmCSSOpenRequestsWidgetOutput
                              ?.pendingCustomerActionCount ? "-35px" : "0px"
                            }}
                          >
                            {General?.codeLabels["cm_in_progress_request"]
                              ?.label
                              ? General?.codeLabels["cm_in_progress_request"]
                                ?.label
                              : " IN-PROGRESS REQUESTS"}
                          </span>
                        </div>
                        {/* Pending Action Count with Alert Icon */}
                        {/* Pending Action Count with Alert Icon */}
                         {General?.dashboard?.cmCSSOpenRequestsWidgetOutput?.pendingCustomerActionCount>0 && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "0.5rem",
                marginTop: "0.5rem",
                flexWrap: "nowrap",
              }}
            >
              <div
                style={{
                  width: "28px",
                  height: "28px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                  transform: "translateY(-1px)",
                }}
              >
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ display: "block" }}
                >
                  <polygon points="18,7 32,32 4,32" fill="#FF6A51" />
                  <rect x="17" y="16" width="2" height="8" rx="1" fill="#fff" />
                  <circle cx="18" cy="27" r="1.7" fill="#fff" />
                </svg>
              </div>
              <span
                style={{
                  fontSize: `${0.85 * General.accessibility.fontSize}rem`,
                  color: contrast?.contrastColor ?? ColorAss,
                  fontWeight: 500,
                  lineHeight: 1.2,
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                {(General?.codeLabels["cm_requests_needing_action"]?.label ?? "You have {no} requests needing action").replace(
                  /\{no\}/g,
                  String(General?.dashboard?.cmCSSOpenRequestsWidgetOutput?.pendingCustomerActionCount ?? 0)
                )}
              </span>
            </div>

                         )}


                      </MainCardDetails>
                    </MainCard>
                    <MainCard
                      style={{
                        fontSize: `${General.accessibility.fontSize}rem`,
                        padding: "1rem",
                        paddingBottom: "2rem",
                        backgroundColor: contrast?.contrastBackground
                          ? contrast?.contrastBackground
                          : "",
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : ColorAss,
                      }}
                      color={General.contrast.contrastColor ? General.contrast.contrastColor : ColorAss}
                      onClick={() => {
                        viewAll(6);
                      }}
                    >
                      <MainCardTitle>
                        <span
                          style={{
                            fontFamily: "Segoe UI",
                            fontStyle: "normal",
                            fontWeight: "700",
                            fontSize: `${General.accessibility.fontSize}rem`,
                            lineHeight: "16px",
                            color: contrast?.contrastColor
                              ? contrast?.contrastColor
                              : ColorAss,
                          }}
                        >
                          {General?.codeLabels["cm_active_nocs"]?.label
                            ? General?.codeLabels["cm_active_nocs"]?.label
                            : "ACTIVE NOCS"}
                        </span>
                        <div
                          style={{
                            backgroundColor: "rgba(98, 170, 81, 0.2)", // Background color with 50% opacity
                          }}
                        >
                          {/* <img style={{ fill: 'red' }} src={nocs} alt="" /> */}
                          <svg
                            width="19" height="23" viewBox="0 0 19 23" fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M9.5 0.0419922C8.76019 0.0419922 8.01898 0.272217 7.38727 0.732666L6.41724 1.43738H1.23438C0.641968 1.43738 0.15625 1.9231 0.15625 2.5155V21.203C0.15625 21.7954 0.641968 22.2811 1.23438 22.2811H17.7656C18.358 22.2811 18.8438 21.7954 18.8438 21.203V2.5155C18.8438 1.9231 18.358 1.43738 17.7656 1.43738H12.5828L11.6127 0.732666C10.981 0.272217 10.2398 0.0433959 9.5 0.0419922ZM9.5 0.76355C10.0924 0.76355 10.6862 0.947449 11.193 1.31525L11.3615 1.43738L12.3469 2.15613L12.6487 2.37512C12.9281 2.57587 13.0938 2.90295 13.0938 3.24829V3.953C13.0938 4.15094 12.9323 4.31238 12.7344 4.31238H6.26562C6.06769 4.31238 5.90625 4.15094 5.90625 3.953V3.24829C5.90625 2.90295 6.0719 2.57587 6.35126 2.37512L6.65308 2.15613L7.63855 1.43738L7.80701 1.31525C8.31378 0.947449 8.90759 0.76355 9.5 0.76355ZM9.5 1.078C8.90479 1.078 8.42188 1.56091 8.42188 2.15613C8.42188 2.75134 8.90479 3.23425 9.5 3.23425C10.0952 3.23425 10.5781 2.75134 10.5781 2.15613C10.5781 1.56091 10.0952 1.078 9.5 1.078ZM1.23438 2.15613H5.55811C5.32086 2.46497 5.1875 2.84961 5.1875 3.24829V3.59363H3.03125C2.63538 3.59363 2.3125 3.9165 2.3125 4.31238V19.4061C2.3125 19.802 2.63538 20.1249 3.03125 20.1249H13.1555C13.4419 20.1249 13.7156 20.0126 13.9164 19.809L16.3716 17.3538C16.5752 17.153 16.6875 16.8793 16.6875 16.5929V4.31238C16.6875 3.9165 16.3646 3.59363 15.9688 3.59363H13.8125V3.24829C13.8125 2.84961 13.6791 2.46497 13.4419 2.15613H17.7656C17.9636 2.15613 18.125 2.31757 18.125 2.5155V21.203C18.125 21.4009 17.9636 21.5624 17.7656 21.5624H1.23438C1.03644 21.5624 0.875 21.4009 0.875 21.203V2.5155C0.875 2.31757 1.03644 2.15613 1.23438 2.15613ZM3.03125 4.31238H5.25208C5.39948 4.72931 5.79816 5.03113 6.26562 5.03113H12.7344C13.2018 5.03113 13.6005 4.72931 13.7479 4.31238H15.9688V16.5311H13.8125C13.4166 16.5311 13.0938 16.854 13.0938 17.2499V19.4061H3.03125V4.31238ZM4.10938 5.74988C3.91144 5.74988 3.75 5.91132 3.75 6.10925V6.828C3.75 7.02594 3.91144 7.18738 4.10938 7.18738C4.30731 7.18738 4.46875 7.02594 4.46875 6.828V6.10925C4.46875 5.91132 4.30731 5.74988 4.10938 5.74988ZM5.90625 5.74988C5.70831 5.74988 5.54688 5.91132 5.54688 6.10925V6.828C5.54688 7.02594 5.70831 7.18738 5.90625 7.18738C6.10419 7.18738 6.26562 7.02594 6.26562 6.828V6.10925C6.26562 5.91132 6.10419 5.74988 5.90625 5.74988ZM7.70312 5.74988C7.50519 5.74988 7.34375 5.91132 7.34375 6.10925V6.828C7.34375 7.02594 7.50519 7.18738 7.70312 7.18738C7.90106 7.18738 8.0625 7.02594 8.0625 6.828V6.10925C8.0625 5.91132 7.90106 5.74988 7.70312 5.74988ZM9.5 5.74988C9.30206 5.74988 9.14062 5.91132 9.14062 6.10925V6.828C9.14062 7.02594 9.30206 7.18738 9.5 7.18738C9.69794 7.18738 9.85938 7.02594 9.85938 6.828V6.10925C9.85938 5.91132 9.69794 5.74988 9.5 5.74988ZM11.2969 5.74988C11.0989 5.74988 10.9375 5.91132 10.9375 6.10925V6.828C10.9375 7.02594 11.0989 7.18738 11.2969 7.18738C11.4948 7.18738 11.6562 7.02594 11.6562 6.828V6.10925C11.6562 5.91132 11.4948 5.74988 11.2969 5.74988ZM13.0938 5.74988C12.8958 5.74988 12.7344 5.91132 12.7344 6.10925V6.828C12.7344 7.02594 12.8958 7.18738 13.0938 7.18738C13.2917 7.18738 13.4531 7.02594 13.4531 6.828V6.10925C13.4531 5.91132 13.2917 5.74988 13.0938 5.74988ZM14.8906 5.74988C14.6927 5.74988 14.5312 5.91132 14.5312 6.10925V6.828C14.5312 7.02594 14.6927 7.18738 14.8906 7.18738C15.0886 7.18738 15.25 7.02594 15.25 6.828V6.10925C15.25 5.91132 15.0886 5.74988 14.8906 5.74988ZM14.1719 9.34363C14.0806 9.34363 13.988 9.37872 13.9178 9.44891L12.7344 10.6323L12.2697 10.1677C12.1293 10.0273 11.9019 10.0273 11.7615 10.1677C11.6212 10.308 11.6212 10.5355 11.7615 10.6758L12.4803 11.3946C12.5505 11.4648 12.6417 11.4999 12.7344 11.4999C12.827 11.4999 12.9183 11.4648 12.9885 11.3946L14.426 9.95709C14.5663 9.81671 14.5663 9.58929 14.426 9.44891C14.3558 9.37872 14.2631 9.34363 14.1719 9.34363ZM5.1875 10.0624C4.98956 10.0624 4.82812 10.2238 4.82812 10.4218C4.82812 10.6197 4.98956 10.7811 5.1875 10.7811H7.34375C7.54169 10.7811 7.70312 10.6197 7.70312 10.4218C7.70312 10.2238 7.54169 10.0624 7.34375 10.0624H5.1875ZM8.78125 10.0624C8.58331 10.0624 8.42188 10.2238 8.42188 10.4218C8.42188 10.6197 8.58331 10.7811 8.78125 10.7811H10.2188C10.4167 10.7811 10.5781 10.6197 10.5781 10.4218C10.5781 10.2238 10.4167 10.0624 10.2188 10.0624H8.78125ZM14.1719 12.9374C14.0806 12.9374 13.988 12.9725 13.9178 13.0427L12.7344 14.2261L12.2697 13.7614C12.1293 13.621 11.9019 13.621 11.7615 13.7614C11.6212 13.9018 11.6212 14.1292 11.7615 14.2696L12.4803 14.9883C12.5505 15.0585 12.6417 15.0936 12.7344 15.0936C12.827 15.0936 12.9183 15.0585 12.9885 14.9883L14.426 13.5508C14.5663 13.4105 14.5663 13.183 14.426 13.0427C14.3558 12.9725 14.2631 12.9374 14.1719 12.9374ZM5.1875 13.6561C4.98956 13.6561 4.82812 13.8176 4.82812 14.0155C4.82812 14.2134 4.98956 14.3749 5.1875 14.3749H10.2188C10.4167 14.3749 10.5781 14.2134 10.5781 14.0155C10.5781 13.8176 10.4167 13.6561 10.2188 13.6561H5.1875ZM13.8125 17.2499H15.462L13.8125 18.8994V17.2499Z"
                              fill={
                                General.contrast.contrastColor ? General.contrast.contrastColor : ColorAss
                              }
                            />
                          </svg>
                        </div>
                      </MainCardTitle>
                      <MainCardDetails>
                        <p
                          style={{
                            fontSize: `${5 * General.accessibility.fontSize
                              }rem`,
                          }}
                        >
                          {
                            General.dashboard?.cmCSSActiveNOCWidgetOutput
                              ?.totalNumberOfActiveNOC
                          }
                        </p>
                        <div className="details">
                          <span
                            className={`p`}
                            style={{
                              fontSize: `${General.accessibility.fontSize}rem`,
                              color: contrast?.contrastColor
                                ? contrast?.contrastColor
                                : ColorAss,
                            }}
                          >
                            {General?.codeLabels["cm_noc_avail"]?.label
                              ? General?.codeLabels["cm_noc_avail"]?.label
                              : "NOCs AVAILABLE"}
                          </span>
                        </div>
                      </MainCardDetails>
                    </MainCard>
                  </div>
                  <div>
                    <MainCard
                      style={{
                        fontSize: `${General.accessibility.fontSize}rem`,
                        padding: "1rem",
                        paddingBottom: "2rem",
                        backgroundColor: contrast?.contrastBackground
                          ? contrast?.contrastBackground
                          : "",
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : ColorAss,
                      }}
                      color={General.contrast.contrastColor ? General.contrast.contrastColor : ColorAss}
                      onClick={() => setValue(6)}
                    >
                      <MainCardTitle>
                        <span
                          style={{
                            fontFamily: "Segoe UI",
                            fontStyle: "normal",
                            fontWeight: "700",
                            fontSize: `${General.accessibility.fontSize}rem`,
                            lineHeight: "16px",
                            color: contrast?.contrastColor
                              ? contrast?.contrastColor
                              : ColorAss,
                          }}
                        >
                          {General?.codeLabels["cm_myprofile"]?.label !==
                            undefined
                            ? General?.codeLabels["cm_myprofile"]?.label
                            : "MY PROFILE"}
                        </span>
                        <div
                          style={{
                            backgroundColor: "rgba(98, 170, 81, 0.2)", // Background color with 50% opacity
                          }}
                        >
                          {/* <img src={folder} alt="" /> */}
                          <svg
                            width="28" height="21" viewBox="0 0 28 21" fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M2.09277 0.196289C1.4043 0.196289 0.842773 0.757812 0.842773 1.44629V18.5296C0.842773 19.4492 1.58984 20.1963 2.50944 20.1963H22.7992C23.5527 20.1963 24.2152 19.6885 24.4105 18.9528L27.2409 7.58073C27.3337 7.20475 27.2507 6.81413 27.013 6.50977C26.7738 6.2054 26.4141 6.02962 26.0267 6.02962H23.3428V3.94629C23.3428 3.25781 22.7812 2.69629 22.0928 2.69629H11.554C11.222 2.69629 10.9111 2.56771 10.6751 2.33496L9.1224 0.798503C8.73014 0.409505 8.20931 0.196289 7.65755 0.196289H2.09277ZM2.09277 1.02962H7.65755C7.98958 1.02962 8.30046 1.1582 8.53646 1.39095L10.0876 2.92578C10.4814 3.31478 11.0023 3.52962 11.554 3.52962H22.0928C22.3223 3.52962 22.5094 3.7168 22.5094 3.94629V6.02962H7.72266C6.95443 6.02962 6.29036 6.55046 6.10482 7.29427L3.34766 18.4043C3.34603 18.4124 3.11816 19.363 2.50944 19.363C2.05046 19.363 1.67611 18.9886 1.67611 18.5296V1.44629C1.67611 1.2168 1.86328 1.02962 2.09277 1.02962ZM26.0267 6.86296H7.72266C7.33854 6.86296 7.00651 7.12337 6.91374 7.49609L5.00293 15.1963H19.5928C19.8239 15.1963 20.0094 15.3818 20.0094 15.613C20.0094 15.8441 19.8239 16.0296 19.5928 16.0296H4.7946L4.15983 18.5947C4.10938 18.8161 4.00846 19.0977 3.84733 19.363H22.7992C23.1768 19.363 23.5072 19.109 23.6048 18.7445L26.4303 7.37891C26.4629 7.25358 26.4352 7.125 26.3555 7.02409C26.2757 6.92155 26.1569 6.86296 26.0267 6.86296ZM21.2594 15.1963C21.0283 15.1963 20.8428 15.3818 20.8428 15.613C20.8428 15.8441 21.0283 16.0296 21.2594 16.0296H22.9261C23.1572 16.0296 23.3428 15.8441 23.3428 15.613C23.3428 15.3818 23.1572 15.1963 22.9261 15.1963H21.2594ZM5.23079 17.1787C5.27148 17.0111 5.40983 16.8923 5.56934 16.8678C5.62305 16.8581 5.68001 16.8613 5.73535 16.876C5.95833 16.9313 6.09505 17.1576 6.03809 17.3805L5.82975 18.2139C5.78255 18.4027 5.61328 18.5296 5.42611 18.5296C5.39355 18.5296 5.35938 18.5264 5.3252 18.5166C5.10221 18.4613 4.96549 18.235 5.02246 18.012L5.23079 17.1787ZM7.65267 16.8678C7.49316 16.8923 7.35482 17.0111 7.31413 17.1787L7.10579 18.012C7.04883 18.235 7.18555 18.4613 7.40853 18.5166C7.44271 18.5264 7.47689 18.5296 7.50944 18.5296C7.69661 18.5296 7.86589 18.4027 7.91309 18.2139L8.12142 17.3805C8.17839 17.1576 8.04167 16.9313 7.81869 16.876C7.76335 16.8613 7.70638 16.8581 7.65267 16.8678ZM9.39746 17.1787C9.43815 17.0111 9.5765 16.8923 9.736 16.8678C9.78971 16.8581 9.84668 16.8613 9.90202 16.876C10.125 16.9313 10.2617 17.1576 10.2048 17.3805L9.99642 18.2139C9.94922 18.4027 9.77995 18.5296 9.59277 18.5296C9.56022 18.5296 9.52604 18.5264 9.49186 18.5166C9.26888 18.4613 9.13216 18.235 9.18913 18.012L9.39746 17.1787ZM11.8193 16.8678C11.6598 16.8923 11.5215 17.0111 11.4808 17.1787L11.2725 18.012C11.2155 18.235 11.3522 18.4613 11.5752 18.5166C11.6094 18.5264 11.6436 18.5296 11.6761 18.5296C11.8633 18.5296 12.0326 18.4027 12.0798 18.2139L12.2881 17.3805C12.3451 17.1576 12.2083 16.9313 11.9854 16.876C11.93 16.8613 11.873 16.8581 11.8193 16.8678ZM13.5641 17.1787C13.6048 17.0111 13.7432 16.8923 13.9027 16.8678C13.9564 16.8581 14.0133 16.8613 14.0687 16.876C14.2917 16.9313 14.4284 17.1576 14.3714 17.3805L14.1631 18.2139C14.1159 18.4027 13.9466 18.5296 13.7594 18.5296C13.7269 18.5296 13.6927 18.5264 13.6585 18.5166C13.4355 18.4613 13.2988 18.235 13.3558 18.012L13.5641 17.1787ZM15.986 16.8678C15.8265 16.8923 15.6882 17.0111 15.6475 17.1787L15.4391 18.012C15.3822 18.235 15.5189 18.4613 15.7419 18.5166C15.776 18.5264 15.8102 18.5296 15.8428 18.5296C16.0299 18.5296 16.1992 18.4027 16.2464 18.2139L16.4548 17.3805C16.5117 17.1576 16.375 16.9313 16.152 16.876C16.0967 16.8613 16.0397 16.8581 15.986 16.8678ZM17.7308 17.1787C17.7715 17.0111 17.9098 16.8923 18.0693 16.8678C18.123 16.8581 18.18 16.8613 18.2354 16.876C18.4583 16.9313 18.5951 17.1576 18.5381 17.3805L18.3298 18.2139C18.2826 18.4027 18.1133 18.5296 17.9261 18.5296C17.8936 18.5296 17.8594 18.5264 17.8252 18.5166C17.6022 18.4613 17.4655 18.235 17.5225 18.012L17.7308 17.1787ZM20.1527 16.8678C19.9915 16.8923 19.8548 17.0111 19.8141 17.1787L19.6058 18.012C19.5488 18.235 19.6855 18.4613 19.9085 18.5166C19.9427 18.5264 19.9769 18.5296 20.0094 18.5296C20.1966 18.5296 20.3659 18.4027 20.4131 18.2139L20.6214 17.3805C20.6784 17.1576 20.5417 16.9313 20.3187 16.876C20.2633 16.8613 20.2064 16.8581 20.1527 16.8678ZM21.8975 17.1787C21.9382 17.0111 22.0765 16.8923 22.236 16.8678C22.2897 16.8581 22.3467 16.8613 22.402 16.876C22.625 16.9313 22.7617 17.1576 22.7048 17.3805L22.4964 18.2139C22.4492 18.4027 22.2799 18.5296 22.0928 18.5296C22.0602 18.5296 22.026 18.5264 21.9919 18.5166C21.7689 18.4613 21.6322 18.235 21.6891 18.012L21.8975 17.1787Z"
                              fill={
                                General.contrast.contrastColor ? General.contrast.contrastColor : ColorAss
                              }
                            />
                          </svg>
                        </div>
                      </MainCardTitle>
                      <MainCardDetails>
                        <p
                          style={{
                            fontSize: `${5 * General.accessibility.fontSize
                              }rem`,
                          }}
                        >
                          {
                            General.dashboard?.cmCSSActiveAccountsWidgetOutput
                              ?.totalNumberOfActiveAccount
                          }
                        </p>
                        <div className="details">
                          <span
                            className={`p`}
                            style={{
                              fontSize: `${General.accessibility.fontSize}rem`,
                              color: contrast?.contrastColor
                                ? contrast?.contrastColor
                                : ColorAss,
                              fontWeight: "400",
                            }}
                          >
                            {General?.codeLabels["cm_active_acc"]?.label
                              ? General?.codeLabels["cm_active_acc"]?.label
                              : "ACTIVE ACCOUNTS"}
                          </span>
                          {/* <span
                            style={{
                              fontSize: `${General.accessibility.fontSize}rem`,
                              fontWeight: "400",
                              color: contrast?.contrastColor
                                ? contrast?.contrastColor
                                : "#686972",
                            }}
                          >
                            {General?.codeLabels["cm_noresponse"]?.label
                              ? General?.codeLabels["cm_noresponse"]?.label
                              : "NO RESPONSE INACTIVE"}
                          </span> */}
                        </div>
                      </MainCardDetails>
                    </MainCard>
                    <MainCard
                      style={{
                        fontSize: `${General.accessibility.fontSize}rem`,
                        padding: "1rem",
                        paddingBottom: "2rem",
                        backgroundColor: contrast?.contrastBackground
                          ? contrast?.contrastBackground
                          : "",
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : ColorAss,
                      }}
                      color={General.contrast.contrastColor ? General.contrast.contrastColor : ColorAss}
                      onClick={() => {
                        setValue(1);
                        setInnerValue(1);
                      }}
                    >
                      <MainCardTitle>
                        <span
                          style={{
                            fontFamily: "Segoe UI",
                            fontStyle: "normal",
                            fontWeight: "700",
                            fontSize: `${General.accessibility.fontSize}rem`,
                            lineHeight: "16px",
                            color: contrast?.contrastColor
                              ? contrast?.contrastColor
                              : ColorAss
                          }}
                        >
                          {General?.codeLabels["cm_my_bills"]?.label
                            ? General?.codeLabels["cm_my_bills"]?.label
                            : "MY BILLS"}
                        </span>
                        <div
                          style={{
                            backgroundColor: "rgba(98, 170, 81, 0.2)", // Background color with 50% opacity
                          }}
                        >
                          {/* <img src={bill} alt="" /> */}
                          <svg
                            width="18" height="20" viewBox="0 0 18 20" fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M16.086 0.000471055C15.9972 -0.0041207 15.9099 0.024962 15.8319 0.0831282L14.4986 1.10256L13.1654 0.122926C13.0093 0.0050632 12.8532 0.0050632 12.697 0.122926L11.3638 1.10256L10.0306 0.122926C9.87444 0.0050632 9.71831 0.0050632 9.56218 0.122926L8.22896 1.10256L6.89573 0.122926C6.7396 0.0050632 6.58347 0.0050632 6.42734 0.122926L5.09411 1.10256L3.76089 0.122926C3.60476 0.0050632 3.44863 0.0050632 3.2925 0.122926L1.95928 1.10256L0.626049 0.122926C0.509718 0.0448612 0.352057 0.0050632 0.234194 0.0831282C0.078065 0.122926 0 0.240789 0 0.396918V18.8141C0 18.932 0.039798 19.01 0.117863 19.0881L0.901573 19.8718C0.979638 19.9499 1.0577 19.9897 1.17557 19.9897C1.25363 19.9897 1.33169 19.9514 1.40976 19.9116L2.74299 18.932L4.07621 19.9116C4.23234 20.0295 4.38847 20.0295 4.5446 19.9116L5.87782 18.932L7.21105 19.9116C7.36718 20.0295 7.52331 20.0295 7.67944 19.9116L9.01266 18.932L10.3459 19.9116C10.502 20.0295 10.6581 20.0295 10.8143 19.9116L12.1475 18.932L13.4807 19.9116C13.6369 20.0295 13.793 20.0295 13.9491 19.9116L15.2823 18.932L16.6156 19.9116C16.7319 19.9897 16.8896 20.0295 17.0074 19.9514C17.1238 19.8718 17.2416 19.7539 17.2416 19.5978V1.18063C17.2416 1.06277 17.2018 0.984701 17.1238 0.906636L16.34 0.122926C16.262 0.0448612 16.1747 0.0050632 16.086 0.000471055ZM3.5267 0.866838L4.85992 1.84648C5.01605 1.96434 5.17218 1.96434 5.32831 1.84648L6.66153 0.866838L7.99476 1.84648C8.15089 1.96434 8.30702 1.96434 8.46315 1.84648L9.79638 0.866838L11.1296 1.84648C11.2857 1.96434 11.4419 1.96434 11.598 1.84648L12.9312 0.866838L14.2644 1.84648C14.4206 1.96434 14.5767 1.96434 14.7328 1.84648L16.0278 0.866838L16.4579 1.33676V14.8956C16.2222 14.8956 16.0661 15.0517 16.0661 15.2874V16.0711C16.0661 16.3068 16.2222 16.463 16.4579 16.463V18.8141L15.5165 18.1085C15.3604 17.9906 15.2043 17.9906 15.0482 18.1085L13.7149 19.1279L12.3817 18.1483C12.3036 18.0702 12.2256 18.0304 12.1475 18.0304C12.0694 18.0304 11.9914 18.0687 11.9133 18.1085L10.5801 19.1279L9.24686 18.1483C9.09073 18.0304 8.9346 18.0304 8.77847 18.1483L7.44524 19.1279L6.11202 18.1483C5.95589 18.0304 5.79976 18.0304 5.64363 18.1483L4.3104 19.1279L2.97718 18.1483C2.82105 18.0304 2.66492 18.0304 2.50879 18.1483L1.21383 19.1279L0.78371 18.6564V16.463C1.01944 16.463 1.17557 16.3068 1.17557 16.0711V15.2874C1.17557 15.0517 1.01944 14.8956 0.78371 14.8956V1.18063L1.72508 1.88627C1.88121 2.00414 2.03734 2.00414 2.19347 1.88627L3.5267 0.866838ZM3.13484 4.31547C3.13484 4.07974 3.29097 3.92361 3.5267 3.92361H9.79638C10.0321 3.92361 10.1882 4.07974 10.1882 4.31547C10.1882 4.55119 10.0321 4.70732 9.79638 4.70732H3.5267C3.29097 4.70732 3.13484 4.55119 3.13484 4.31547ZM11.3638 3.92361C11.1281 3.92361 10.9719 4.07974 10.9719 4.31547C10.9719 4.55119 11.1281 4.70732 11.3638 4.70732H13.7149C13.9507 4.70732 14.1068 4.55119 14.1068 4.31547C14.1068 4.07974 13.9507 3.92361 13.7149 3.92361H11.3638ZM3.13484 5.88289C3.13484 5.64716 3.29097 5.49103 3.5267 5.49103H7.8371C8.07283 5.49103 8.22895 5.64716 8.22895 5.88289C8.22895 6.11861 8.07283 6.27474 7.8371 6.27474H3.5267C3.29097 6.27474 3.13484 6.11861 3.13484 5.88289ZM12.5394 5.49103C12.3036 5.49103 12.1475 5.64716 12.1475 5.88289V6.27474C11.4817 6.27474 10.9719 6.78446 10.9719 7.45031V8.62587C10.9719 9.29172 11.4817 9.80144 12.1475 9.80144H12.9312C13.1669 9.80144 13.3231 9.95757 13.3231 10.1933V11.3689C13.3231 11.6046 13.1669 11.7607 12.9312 11.7607H12.1475C11.9118 11.7607 11.7556 11.6046 11.7556 11.3689V10.977C11.7556 10.7413 11.5995 10.5851 11.3638 10.5851C11.1281 10.5851 10.9719 10.7413 10.9719 10.977V11.3689C10.9719 12.0347 11.4817 12.5444 12.1475 12.5444V12.9363C12.1475 13.172 12.3036 13.3281 12.5394 13.3281C12.7751 13.3281 12.9312 13.172 12.9312 12.9363V12.5444C13.5971 12.5444 14.1068 12.0347 14.1068 11.3689V10.1933C14.1068 9.52745 13.5971 9.01773 12.9312 9.01773H12.1475C11.9118 9.01773 11.7556 8.8616 11.7556 8.62587V7.45031C11.7556 7.21458 11.9118 7.05845 12.1475 7.05845H12.9312C13.1669 7.05845 13.3231 7.21458 13.3231 7.45031V7.84216C13.3231 8.07789 13.4792 8.23402 13.7149 8.23402C13.9507 8.23402 14.1068 8.07789 14.1068 7.84216V7.45031C14.1068 6.78446 13.5971 6.27474 12.9312 6.27474V5.88289C12.9312 5.64716 12.7751 5.49103 12.5394 5.49103ZM3.13484 9.01773C3.13484 8.782 3.29097 8.62587 3.5267 8.62587H7.44524C7.68097 8.62587 7.8371 8.782 7.8371 9.01773C7.8371 9.25345 7.68097 9.40958 7.44524 9.40958H3.5267C3.29097 9.40958 3.13484 9.25345 3.13484 9.01773ZM3.5267 10.1933C3.29097 10.1933 3.13484 10.3494 3.13484 10.5851C3.13484 10.8209 3.29097 10.977 3.5267 10.977H8.62081C8.85654 10.977 9.01266 10.8209 9.01266 10.5851C9.01266 10.3494 8.85654 10.1933 8.62081 10.1933H3.5267ZM3.13484 12.1526C3.13484 11.9168 3.29097 11.7607 3.5267 11.7607H5.09412C5.32984 11.7607 5.48597 11.9168 5.48597 12.1526C5.48597 12.3883 5.32984 12.5444 5.09412 12.5444H3.5267C3.29097 12.5444 3.13484 12.3883 3.13484 12.1526ZM6.66154 11.7607C6.42581 11.7607 6.26968 11.9168 6.26968 12.1526C6.26968 12.3883 6.42581 12.5444 6.66154 12.5444H7.44524C7.68097 12.5444 7.8371 12.3883 7.8371 12.1526C7.8371 11.9168 7.68097 11.7607 7.44524 11.7607H6.66154ZM2.35113 15.2874C2.35113 15.0517 2.50726 14.8956 2.74299 14.8956C2.97871 14.8956 3.13484 15.0517 3.13484 15.2874V16.0711C3.13484 16.3068 2.97871 16.463 2.74299 16.463C2.50726 16.463 2.35113 16.3068 2.35113 16.0711V15.2874ZM4.70226 14.8956C4.46653 14.8956 4.3104 15.0517 4.3104 15.2874V16.0711C4.3104 16.3068 4.46653 16.463 4.70226 16.463C4.93799 16.463 5.09411 16.3068 5.09411 16.0711V15.2874C5.09411 15.0517 4.93799 14.8956 4.70226 14.8956ZM6.26968 15.2874C6.26968 15.0517 6.42581 14.8956 6.66154 14.8956C6.89726 14.8956 7.05339 15.0517 7.05339 15.2874V16.0711C7.05339 16.3068 6.89726 16.463 6.66154 16.463C6.42581 16.463 6.26968 16.3068 6.26968 16.0711V15.2874ZM8.62081 14.8956C8.38509 14.8956 8.22896 15.0517 8.22896 15.2874V16.0711C8.22896 16.3068 8.38509 16.463 8.62081 16.463C8.85654 16.463 9.01266 16.3068 9.01266 16.0711V15.2874C9.01266 15.0517 8.85654 14.8956 8.62081 14.8956ZM10.1882 15.2874C10.1882 15.0517 10.3444 14.8956 10.5801 14.8956C10.8158 14.8956 10.9719 15.0517 10.9719 15.2874V16.0711C10.9719 16.3068 10.8158 16.463 10.5801 16.463C10.3444 16.463 10.1882 16.3068 10.1882 16.0711V15.2874ZM12.5394 14.8956C12.3036 14.8956 12.1475 15.0517 12.1475 15.2874V16.0711C12.1475 16.3068 12.3036 16.463 12.5394 16.463C12.7751 16.463 12.9312 16.3068 12.9312 16.0711V15.2874C12.9312 15.0517 12.7751 14.8956 12.5394 14.8956ZM14.1068 15.2874C14.1068 15.0517 14.2629 14.8956 14.4986 14.8956C14.7344 14.8956 14.8905 15.0517 14.8905 15.2874V16.0711C14.8905 16.3068 14.7344 16.463 14.4986 16.463C14.2629 16.463 14.1068 16.3068 14.1068 16.0711V15.2874Z"
                              fill={
                                General.contrast.contrastColor ? General.contrast.contrastColor : ColorAss
                              }
                            />
                          </svg>
                        </div>
                      </MainCardTitle>
                      <MainCardDetails>
                        <p
                          style={{
                            fontSize: `${5 * General.accessibility.fontSize
                              }rem`,
                          }}
                        >
                          {
                            General.dashboard?.cmCSSBillsWidgetOutput
                              ?.totalNumberOfBills
                          }
                        </p>
                        <div className="details">
                          <span
                            className={`p`}
                            style={{
                              fontSize: `${General.accessibility.fontSize}rem`,
                              color: contrast?.contrastColor
                                ? contrast?.contrastColor
                                : ColorAss,
                            }}
                          >
                            {General?.codeLabels["cm_bills_available"]?.label
                              ? General?.codeLabels["cm_bills_available"]?.label
                              : "BILLS AVAILABLE"}
                          </span>
                        </div>
                      </MainCardDetails>
                    </MainCard>
                    <MainCard
                      style={{
                        fontSize: `${General.accessibility.fontSize}rem`,
                        padding: "1rem",
                        paddingBottom: "2rem",
                        backgroundColor: contrast?.contrastBackground
                          ? contrast?.contrastBackground
                          : "",
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : ColorAss,
                      }}
                      color={General.contrast.contrastColor ? General.contrast.contrastColor : ColorAss}
                      onClick={() => setValue(7)}
                    >
                      <MainCardTitle>
                        <span
                          style={{
                            fontFamily: "Segoe UI",
                            fontStyle: "normal",
                            fontWeight: "700",
                            fontSize: `${General.accessibility.fontSize}rem`,
                            lineHeight: "16px",
                            color: contrast?.contrastColor
                              ? contrast?.contrastColor
                              : ColorAss,
                          }}
                        >
                          {General?.codeLabels["cm_autostatus"]?.label
                            ? General?.codeLabels["cm_autostatus"]?.label
                            : "AUTO PAYMENT STATUS"}
                        </span>
                        <div
                          style={{
                            backgroundColor: "rgba(98, 170, 81, 0.2)", // Background color with 50% opacity
                          }}
                        >
                          {/* <img src={checkout} alt="" /> */}
                          <svg
                            width="32" height="20" viewBox="0 0 32 20" fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M9.35619 0.876736C9.76417 0.348958 10.3961 0 11.1114 0H29.7781C31.0003 0 32.0003 1 32.0003 2.22222V12.8889C32.0003 14.1111 31.0003 15.1111 29.7781 15.1111H23.5645L23.0958 16.7865L23.0923 16.7934C22.8961 17.4497 22.5801 18.0208 22.1305 18.4392C21.6808 18.8576 21.0888 19.1111 20.4291 19.1111C19.6045 19.1111 19.0506 18.7986 18.7173 18.4583C18.682 18.534 18.6531 18.6093 18.6245 18.684C18.5632 18.8441 18.503 19.0012 18.3822 19.1528C18.009 19.6198 17.4222 20 16.667 20C15.686 20 14.8458 19.4062 14.4586 18.5677C14.443 18.5851 14.4378 18.5938 14.4326 18.6024C14.4274 18.6111 14.4222 18.6198 14.4065 18.6372C14.0055 19.066 13.4274 19.5556 12.667 19.5556C11.8926 19.5556 11.2017 19.191 10.7538 18.6267C9.41174 19.4878 7.84751 19.9514 6.24334 19.9514H0.889173C0.729451 19.9531 0.580146 19.8698 0.498548 19.7309C0.418687 19.592 0.418687 19.4219 0.498548 19.283C0.580146 19.1441 0.729451 19.0608 0.889173 19.0625H6.24334C7.89091 19.0625 9.4916 18.5174 10.7972 17.5122L18.101 11.8837L18.3475 12.2049C18.2156 12.0122 18.2538 11.75 18.436 11.6042C18.8475 11.276 19.1114 10.7847 19.1114 10.2222C19.1114 9.23611 18.3197 8.44444 17.3336 8.44444C17.0239 8.44444 16.6393 8.63326 16.287 8.80623L16.287 8.80624L16.2069 8.84549C16.035 8.92708 15.8319 8.8941 15.6965 8.75868L15.917 8.97917L8.06278 12.6858C7.91869 12.7569 7.74681 12.7448 7.61313 12.6545C7.48119 12.5625 7.40827 12.408 7.42216 12.2483C7.43605 12.0885 7.53674 11.9479 7.68258 11.8819L8.88917 11.3125V2.22222C8.88917 2.03472 8.91869 1.85764 8.96383 1.68229C8.3232 1.34722 7.79195 1.25521 7.18431 1.39757C6.50202 1.56076 5.68778 2.04861 4.63223 2.92361C3.38917 3.95312 0.729451 6.17188 0.729451 6.17188C0.540215 6.32986 0.260701 6.30382 0.102715 6.11458C-0.0535351 5.92708 -0.0292294 5.64583 0.160007 5.48785C0.160007 5.48785 2.81799 3.27083 4.06452 2.23785C5.16522 1.32639 6.07147 0.748264 6.97945 0.534722C7.43431 0.427084 7.88223 0.421875 8.32667 0.50868C8.67042 0.576389 9.01417 0.703125 9.35619 0.876736ZM29.7781 0.888889H11.1114C10.3701 0.888889 9.77806 1.4809 9.77806 2.22222V3.11111H31.1114V2.22222C31.1114 1.4809 30.5194 0.888889 29.7781 0.888889ZM9.77806 4.88889H31.1114V12.8889C31.1114 13.6302 30.5194 14.2222 29.7781 14.2222H16.5229L18.9951 12.3177C19.0628 12.2656 19.1149 12.1944 19.1426 12.1128C19.6479 11.6302 20.0003 10.9792 20.0003 10.2222C20.0003 8.75521 18.8006 7.55556 17.3336 7.55556C16.7698 7.55556 16.3028 7.79643 15.9794 7.9633L15.9793 7.9633C15.9303 7.9886 15.8846 8.01219 15.8423 8.03299C15.8354 8.03646 15.8284 8.03993 15.8215 8.04167L9.77806 10.8941V4.88889ZM11.5558 6.22222C11.5558 5.97743 11.7555 5.77778 12.0003 5.77778C12.2451 5.77778 12.4447 5.97743 12.4447 6.22222C12.4447 6.46701 12.2451 6.66667 12.0003 6.66667C11.7555 6.66667 11.5558 6.46701 11.5558 6.22222ZM13.7781 5.77778C13.5333 5.77778 13.3336 5.97743 13.3336 6.22222C13.3336 6.46701 13.5333 6.66667 13.7781 6.66667C14.0229 6.66667 14.2225 6.46701 14.2225 6.22222C14.2225 5.97743 14.0229 5.77778 13.7781 5.77778ZM15.1114 6.22222C15.1114 5.97743 15.311 5.77778 15.5558 5.77778C15.8006 5.77778 16.0003 5.97743 16.0003 6.22222C16.0003 6.46701 15.8006 6.66667 15.5558 6.66667C15.311 6.66667 15.1114 6.46701 15.1114 6.22222ZM17.3336 5.77778C17.0888 5.77778 16.8892 5.97743 16.8892 6.22222C16.8892 6.46701 17.0888 6.66667 17.3336 6.66667C17.5784 6.66667 17.7781 6.46701 17.7781 6.22222C17.7781 5.97743 17.5784 5.77778 17.3336 5.77778ZM15.5558 10.2222C15.5558 9.97743 15.7555 9.77778 16.0003 9.77778C16.2451 9.77778 16.4447 9.97743 16.4447 10.2222C16.4447 10.467 16.2451 10.6667 16.0003 10.6667C15.7555 10.6667 15.5558 10.467 15.5558 10.2222ZM16.8892 11.1111C16.6444 11.1111 16.4447 11.3108 16.4447 11.5556C16.4447 11.8003 16.6444 12 16.8892 12C17.134 12 17.3336 11.8003 17.3336 11.5556C17.3336 11.3108 17.134 11.1111 16.8892 11.1111ZM22.6409 15.1111H15.3683L11.4777 18.1094C11.7624 18.4497 12.186 18.6667 12.667 18.6667C13.0107 18.6667 13.4326 18.3785 13.7555 18.0295C14.0784 17.6823 14.2815 17.3333 14.2815 17.3333L15.1114 17.5556C15.1114 18.4201 15.8024 19.1111 16.667 19.1111C17.1461 19.1111 17.4326 18.9167 17.6878 18.5972C17.943 18.2778 18.1218 17.8281 18.2416 17.4306L19.101 17.4601C19.101 17.4601 19.1322 17.6181 19.3076 17.8125C19.4829 18.0087 19.7781 18.2222 20.4291 18.2222C20.8735 18.2222 21.2208 18.0729 21.5246 17.7899C21.8284 17.5069 22.0801 17.0781 22.2416 16.5417L22.6409 15.1111ZM15.1114 15.5556C14.8666 15.5556 14.667 15.7552 14.667 16C14.667 16.2448 14.8666 16.4444 15.1114 16.4444C15.3562 16.4444 15.5558 16.2448 15.5558 16C15.5558 15.7552 15.3562 15.5556 15.1114 15.5556ZM18.667 16C18.667 15.7552 18.8666 15.5556 19.1114 15.5556C19.3562 15.5556 19.5558 15.7552 19.5558 16C19.5558 16.2448 19.3562 16.4444 19.1114 16.4444C18.8666 16.4444 18.667 16.2448 18.667 16Z"
                              fill={
                                General.contrast.contrastColor ? General.contrast.contrastColor : ColorAss
                              }
                            />
                          </svg>
                        </div>
                      </MainCardTitle>
                      <MainCardDetails>
                        <p
                          style={{
                            fontSize: `${5 * General.accessibility.fontSize
                              }rem`,
                          }}
                        >
                          {
                            General.dashboard?.cmCSSAccountsAutopayWidgetOutput
                              ?.totalNumberOfAcctWithApay
                          }
                        </p>
                        <div className="details last">
                          <button
                            disabled
                            style={{
                              fontSize: `${General.accessibility.fontSize}rem`,
                              backgroundColor: General.dashboard?.cmCSSAccountsAutopayWidgetOutput?.totalNumberOfSavedCards > 0 ? (contrast?.contrastBackground
                                ? contrast?.contrastBackground
                                : "rgba(98, 170, 81, 0.2)") : "rgba(255, 106, 81, 0.2)", // Background color with 50% opacity",
                              color: General.dashboard?.cmCSSAccountsAutopayWidgetOutput?.totalNumberOfSavedCards > 0 ? (contrast?.contrastColor
                                ? contrast?.contrastColor
                                : "") : "rgba(199, 67, 67, 1)",
                              padding: "2px 10px ",
                              fontWeight: 500,

                            }}
                          >
                            {General.dashboard?.cmCSSAccountsAutopayWidgetOutput?.totalNumberOfSavedCards > 0 ? General?.codeLabels["cm_dash_enabled"]?.label
                              ? General?.codeLabels["cm_dash_enabled"]?.label
                              : "ENABLED" : General?.codeLabels['cm_dash_disabled']?.label ? General?.codeLabels['cm_dash_disabled']?.label : "DISABLED"}
                          </button>
                          <span
                            className={`p`}
                            style={{
                              fontSize: `${General.accessibility.fontSize}rem`,
                              color: contrast?.contrastColor
                                ? contrast?.contrastColor
                                : ColorAss,
                            }}
                          >
                            {General.dashboard?.cmCSSAccountsAutopayWidgetOutput?.totalNumberOfSavedCards}{" "}
                            {General?.codeLabels["cm_saved_cards"]?.label !==
                              undefined
                              ? General?.codeLabels["cm_saved_cards"]?.label
                              : "SAVED CARDS"}
                          </span>
                        </div>
                      </MainCardDetails>
                    </MainCard>
                  </div>
                </MainCards>
              }
              <MyFavorites
                style={{
                  marginTop: "2rem",
                  flex: "1",
                  height: "100%",
                  backgroundColor: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : "",
                  color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
                }}
              >
                <span
                  style={{
                    fontSize: `${2 * General.accessibility.fontSize}rem`,

                    lineHeight: "48px",
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : ColorAss,
                    fontWeight: 700,
                  }}
                >
                  {General?.codeLabels["cm_dash_fav"]?.label
                    ? General?.codeLabels["cm_dash_fav"]?.label
                    : "My Favorites"}
                </span>
                {User.favourites.length > 0 ? renderFavourites() : null}
              </MyFavorites>
            </div>
          </MainCardsContainer>
        ) : (
          <div
            className=" mt-2 pb-4 pt-2"
            style={{
              backgroundColor: contrast?.contrastBackground
                ? contrast?.contrastBackground
                : "#E7E9F8",
              color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
            }}
          >
            <div className="mt-3 pt-2" style={{ padding: "0% 1%" }}>
              <p
                style={{
                  fontSize: `${1.4 * General.accessibility.fontSize}rem`,
                  color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
                }}
                className={`mb-0 slider-header-text1 pt-4 pb-2`}
              >
                {" "}
                {General?.codeLabels["cm_hi"]?.label
                  ? General?.codeLabels["cm_hi"]?.label
                  : "hi"}{" "}
                {General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA" ? User?.profile?.arName?.trim()?.split(/[,\s]+/)?.slice(0, 1)?.join(' ') : User?.profile?.name?.trim()?.split(/[,\s]+/)?.slice(0, 1)?.join(' ')}
              </p>
              <p
                style={{
                  textAlign: "start",
                  fontSize: `${0.9 * General.accessibility.fontSize}rem`,
                  color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
                }}
                className={`mb-0 slider-header-text2`}
              >
                {" "}
                {General?.codeLabels["cm_ajman_welcome"]?.label
                  ? General?.codeLabels["cm_ajman_welcome"]?.label
                  : "Welcome to your Ajman Sewerage Dashboard"}
              </p>
              <div className="py-3 ">
                <Carousel1 setValue={setValue} setInnerValue={setInnerValue} data={data1} />
              </div>
            </div>

            <div
              className="py-3 mt-2 pl-3 "
              style={{
                backgroundColor: contrast?.contrastBackground
                  ? contrast?.contrastBackground
                  : "white",
                color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
              }}
            >
              <p
                style={{
                  fontSize: `${General.accessibility.fontSize}rem`,
                  color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
                }}
                className={`mb-3 slider2 pl-2`}
              >
                {" "}
                {General?.codeLabels["cm_dash_fav"]?.label
                  ? General?.codeLabels["cm_dash_fav"]?.label
                  : "My Favorites"}
              </p>
              <Carousel2 setValue={setValue} setInnerValue={setInnerValue} data={User?.favourites} favourites={null} fromRecent={false} />
            </div>
          </div>
        )}

        <BaseCardsContainer
          style={{
            gap: "1.75rem",
            marginBottom: "1rem",
            width: General?.isLargeScreen ? "" : "100vw",
          }}
        >
          {/* <div style={{ flex: 4, display: "block", gap: "1rem" }}> */}
          <div
            style={{
              display: "flex",
              flexDirection: !isLargeScreen ? "column" : "row",
              gap: "1rem",
              width: !isLargeScreen ? "100%" : "76.5%",
            }}
          >
            <BaseCard
              style={{
                backgroundColor: contrast?.contrastBackground
                  ? contrast?.contrastBackground
                  : "",
                color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
              }}
            >
              <div className="title">
                <h3
                  style={{
                    fontSize: isLargeScreen
                      ? `${2 * General.accessibility.fontSize}rem`
                      : `${1.25 * General.accessibility.fontSize}rem`,
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : ColorAss,
                    fontWeight: 900,
                  }}
                >
                  {General?.codeLabels["cm_dash_pending"]?.label
                    ? General?.codeLabels["cm_dash_pending"]?.label
                    : "Pending Payments"}
                </h3>
                <span
                  className={`viewall`}
                  onClick={() => {
                    viewAll(1);
                  }}
                  style={{
                    fontSize: isLargeScreen
                      ? `${General.accessibility.fontSize}rem`
                      : "13px",
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : ColorAss,
                    display: "flex",
                    alignItems: "baseline",
                    gap: "5px",
                  }}
                >
                  {General?.codeLabels["cm_view_all"]?.label !== undefined
                    ? General?.codeLabels["cm_view_all"]?.label
                    : "VIEW ALL"}
                  <Box
                    sx={{
                      padding: "0.5rem",
                      "@media (max-width: 768px)": {
                        display: "none", // Hide the box below 768px
                      },
                    }}
                  >
                    <img
                      style={{
                        transform:
                          General?.codeLabels["cm_pdc_paymentaccounts"]
                            ?.languageCode !== "ENG"
                            ? "rotate(180deg)"
                            : "",
                        marginBottom: "0.3rem",
                      }}
                      src={path}
                    />{" "}
                  </Box>
                </span>
              </div>

              <div
                style={{
                  width: "100%",
                  padding: !isLargeScreen ? "" : "0px 2rem",
                }}
              >
                <table
                  style={{
                    borderSpacing: "0",
                    width: "100%",
                  }}
                >
                  <thead
                    style={{
                      margin: "0",
                      backgroundColor: contrast?.contrastBackground
                        ? contrast?.contrastBackground
                        : "rgba(229, 239, 242, 0.7)",
                      width: "100%",
                    }}
                  >
                    <tr style={{}}>
                      <th
                        style={{
                          backgroundColor: contrast?.contrastBackground
                            ? contrast?.contrastBackground
                            : "#edf4f6",

                          fontSize: `${0.875 * General.accessibility.fontSize
                            }rem`,
                          fontWeight: "700",

                          justifyContent: "space-between",
                          textAlign: General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA" ? "start" : "left",
                        }}
                      >
                        {General?.codeLabels["cm_pdc_paymentaccounts"]
                          ?.label !== undefined
                          ? General?.codeLabels["cm_pdc_paymentaccounts"]?.label
                          : "Account"}
                      </th>
                      <th
                        style={{
                          textAlign: "start",
                          fontSize: `${0.875 * General.accessibility.fontSize
                            }rem`,
                        }}
                      >
                        {General?.codeLabels["cm_asreqtypetable"]?.label !==
                          undefined
                          ? General?.codeLabels["cm_asreqtypetable"]?.label
                          : "Type"}
                      </th>
                      <th
                        style={{
                          fontSize: `${0.875 * General.accessibility.fontSize
                            }rem`,
                          textAlign: "center",
                        }}
                      >
                        {General?.codeLabels["cm_amt_due"]?.label !== undefined
                          ? General?.codeLabels["cm_amt_due"]?.label
                          : "Amount Due"}
                        &nbsp;
                        {General?.codeLabels["cm_mob_aed"]?.label !== undefined
                          ? General?.codeLabels["cm_mob_aed"]?.label
                          : "AED"}
                      </th>
                    </tr>
                  </thead>
                  {PaymentReceipts?.pendingPayments?.map((payment) => {
                    return (
                      <tbody
                        style={{
                          backgroundColor: contrast?.contrastBackground
                            ? contrast?.contrastBackground
                            : "",
                          color: contrast?.contrastColor
                            ? contrast?.contrastColor
                            : ColorAss,
                        }}
                      >
                        <tr style={{ borderBottom: "1px solid #101e8e" }}>
                          <td
                            style={{
                              borderBottom: "1px solid #ddd",
                              color: contrast?.contrastColor
                                ? contrast?.contrastColor
                                : ColorAss,
                              fontSize: `${0.875 * General.accessibility.fontSize
                                }rem`,
                            }}
                          >
                            {payment.accountNumber}
                          </td>

                          <td
                            style={{
                              borderBottom: "1px solid #ddd",
                              fontSize: `${0.875 * General.accessibility.fontSize
                                }rem`,
                              color: contrast?.contrastColor
                                ? contrast?.contrastColor
                                : ColorAss,
                            }}
                          >
                            {" "}
                            {payment.type}
                          </td>
                          <td
                            style={{
                              borderBottom: "1px solid #ddd",
                              textAlign: "center",
                              fontSize: `${0.875 * General.accessibility.fontSize
                                }rem`,
                              color: contrast?.contrastColor
                                ? contrast?.contrastColor
                                : ColorAss,
                            }}
                          >
                            {payment.amountDue}
                          </td>
                        </tr>
                      </tbody>
                    );
                  })}
                </table>
              </div>
            </BaseCard>
            <BaseCard
              style={{
                backgroundColor: contrast?.contrastBackground
                  ? contrast?.contrastBackground
                  : "",
                color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
              }}
            >
              <div
                className="title"
              // style={{
              //   paddingTop: "30px",
              // }}
              >
                <h3
                  style={{
                    fontSize: isLargeScreen
                      ? `${2 * General.accessibility.fontSize}rem`
                      : `${1.25 * General.accessibility.fontSize}rem`,
                    margin: "0",
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : ColorAss,
                    fontWeight: 900,
                  }}
                >
                  {General?.codeLabels["cm_dash_recent"]?.label
                    ? General?.codeLabels["cm_dash_recent"]?.label
                    : "Recent Requests"}
                </h3>
                <span
                  className={`viewall`}
                  onClick={() => {
                    viewAll(2);
                  }}
                  style={{
                    fontSize: isLargeScreen
                      ? `${General.accessibility.fontSize}rem`
                      : "13px",
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : ColorAss,
                    display: "flex",
                    alignItems: "baseline",
                    gap: "5px",
                  }}
                >
                  {General?.codeLabels["cm_view_all"]?.label !== undefined
                    ? General?.codeLabels["cm_view_all"]?.label
                    : "VIEW ALL"}
                  <Box
                    sx={{
                      padding: "0.5rem",
                      "@media (max-width: 768px)": {
                        display: "none", // Hide the box below 768px
                      },
                    }}
                  >
                    <img
                      style={{
                        transform:
                          General?.codeLabels["cm_pdc_paymentaccounts"]
                            ?.languageCode !== "ENG"
                            ? "rotate(180deg)"
                            : "",
                        marginBottom: "0.3rem",
                      }}
                      src={path}
                    />{" "}
                  </Box>
                </span>
              </div>

              <div
                style={{
                  width: "100%",
                  padding: !isLargeScreen ? "" : "0px 2rem",
                }}
              >
                <table
                  style={{
                    padding: "3rem",
                    borderSpacing: "0",
                    width: "100%",
                  }}
                >
                  <thead
                    style={{
                      margin: "0",
                      backgroundColor: contrast?.contrastBackground
                        ? contrast?.contrastBackground
                        : "rgba(229, 239, 242, 0.7)",
                    }}
                  >
                    <tr style={{}}>
                      <th
                        style={{
                          backgroundColor: contrast?.contrastBackground
                            ? contrast?.contrastBackground
                            : "#edf4f6",
                          width: "10%",
                          fontSize: `${0.875 * General.accessibility.fontSize
                            }rem`,
                          fontWeight: "700",
                          display: "flex",
                          justifyContent: "space-between",
                          color: contrast?.contrastColor
                            ? contrast?.contrastColor
                            : ColorAss,

                        }}
                      >
                        {General?.codeLabels["cm_ref"]?.label !== undefined
                          ? General?.codeLabels["cm_ref"]?.label
                          : "Ref"}
                      </th>
                      <th
                        style={{
                          width: "50%",
                          textAlign: "start",
                          fontSize: `${0.875 * General.accessibility.fontSize
                            }rem`,
                          color: contrast?.contrastColor
                            ? contrast?.contrastColor
                            : ColorAss,
                        }}
                      >
                        {General?.codeLabels["cm_asreqtypetable"]?.label !==
                          undefined
                          ? General?.codeLabels["cm_asreqtypetable"]?.label
                          : "Type"}
                      </th>
                      <th
                        style={{
                          width: "30%",
                          textAlign: "center",
                          fontSize: `${0.875 * General.accessibility.fontSize
                            }rem`,
                          color: contrast?.contrastColor
                            ? contrast?.contrastColor
                            : ColorAss,
                        }}
                      >
                        {General?.codeLabels["cm_noc_status"]?.label !==
                          undefined
                          ? General?.codeLabels["cm_noc_status"]?.label
                          : "Status"}
                      </th>
                    </tr>
                  </thead>
                  {General?.recentRequests?.map((request) => {
                    return (
                      <tbody style={{}}>
                        <tr style={{ borderBottom: "1px solid #101e8e" }}>
                          <td
                            style={{
                              borderBottom: "1px solid #ddd",
                              color: contrast?.contrastColor
                                ? contrast?.contrastColor
                                : ColorAss,
                              fontSize: `${0.875 * General.accessibility.fontSize
                                }rem`,
                            }}
                          >
                            {request.requestId}
                          </td>

                          <td
                            style={{
                              borderBottom: "1px solid #ddd",
                              fontSize: `${0.875 * General.accessibility.fontSize
                                }rem`,
                              color: contrast?.contrastColor
                                ? contrast?.contrastColor
                                : ColorAss,
                            }}
                          >
                            {" "}
                            {request.requestDescription}
                          </td>
                          <td
                            style={{
                              borderBottom: "1px solid #ddd",
                              textAlign: "center",
                              fontSize: `${0.875 * General.accessibility.fontSize
                                }rem`,
                              color: contrast?.contrastColor
                                ? contrast?.contrastColor
                                : ColorAss,
                            }}
                          >
                            {request.requestStatus == "Started" ? (
                              <Box
                                sx={{
                                  "@media (max-width: 768px)": {
                                    padding: 0, // Remove padding
                                    backgroundColor: "transparent", // Hide background
                                    color: contrast?.contrastBackground // Use background color as text color
                                      ? contrast?.contrastBackground
                                      : General?.colorClass ? General?.colorClass : "#EB7C00",
                                  },
                                  // Add the other styles that should apply regardless of screen width
                                  fontSize: `${0.875 * General.accessibility.fontSize
                                    }rem`,
                                  backgroundColor: contrast?.contrastBackground
                                    ? contrast?.contrastBackground
                                    : "#EB7C00",
                                  color: contrast?.contrastColor
                                    ? contrast?.contrastColor
                                    : General?.colorClass ? General?.colorClass : "#fff",
                                  borderRadius: "15px",
                                  whiteSpace: "nowrap",
                                  paddingInline: "20px",
                                  fontWeight: 700,
                                  textTransform: "capitalize",
                                }}
                              >
                                {General?.codeLabels["cm_started"]?.label !==
                                  undefined
                                  ? General?.codeLabels["cm_started"]?.label
                                  : "STARTED"}
                              </Box>
                            ) : request.requestStatus == "Completed" ? (
                              <Box
                                sx={{
                                  "@media (max-width: 768px)": {
                                    padding: 0, // Remove padding
                                    backgroundColor: "transparent", // Hide background
                                    color: contrast?.contrastBackground // Use background color as text color
                                      ? contrast?.contrastBackground
                                      : General?.colorClass ? General?.colorClass : "#34BF13",
                                  },
                                  backgroundColor: contrast?.contrastBackground
                                    ? contrast?.contrastBackground
                                    : "#34BF13",
                                  color: contrast?.contrastColor
                                    ? contrast?.contrastColor
                                    : General?.colorClass ? General?.colorClass : "#fff",
                                  fontSize: `${0.875 * General.accessibility.fontSize
                                    }rem`,
                                  borderRadius: "15px",
                                  whiteSpace: "nowrap",
                                  paddingInline: "20px",
                                  fontWeight: 700,
                                  textTransform: "capitalize",
                                }}
                              >
                                {General?.codeLabels["cm_noc_status1"]
                                  ?.label !== undefined
                                  ? General?.codeLabels["cm_noc_status1"]?.label
                                  : "COMPLETED"}
                              </Box>
                            ) : (
                              <Box
                                sx={{
                                  "@media (max-width: 768px)": {
                                    padding: 0, // Remove padding
                                    backgroundColor: "transparent", // Hide background
                                    color: contrast?.contrastBackground // Use background color as text color
                                      ? contrast?.contrastBackground
                                      : General?.colorClass ? General?.colorClass : "#EBA900",
                                  },
                                  backgroundColor: contrast?.contrastBackground // Use background color as text color
                                    ? contrast?.contrastBackground
                                    : "#EBA900",
                                  color: contrast?.contrastColor
                                    ? contrast?.contrastColor
                                    : General?.colorClass ? General?.colorClass : "#fff",
                                  fontSize: `${0.875 * General.accessibility.fontSize
                                    }rem`,
                                  borderRadius: "15px",
                                  whiteSpace: "nowrap",
                                  paddingInline: "20px",
                                  fontWeight: 700,
                                  textTransform: "capitalize",
                                }}
                              >
                                {General?.codeLabels["cm_dash_inprogress"]
                                  ?.label
                                  ? General?.codeLabels["cm_dash_inprogress"]
                                    ?.label
                                  : "IN-PROGRESS"}
                              </Box>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    );
                  })}
                </table>
              </div>
            </BaseCard>
          </div>

          {isLargeScreen ? (
            <MyFavorites
              style={{
                flex: 1,
                minHeight: "400px",
                backgroundColor: contrast?.contrastBackground
                  ? contrast?.contrastBackground
                  : "",
                color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
              }}
            >
              <span
                style={{
                  fontSize: `${1.8 * General.accessibility.fontSize}rem`,
                  lineHeight: "30px",
                  paddingTop: "4px",
                  color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
                  fontWeight: 900,
                }}
              >
                {General?.codeLabels["cm_dash_commonly"]?.label
                  ? General?.codeLabels["cm_dash_commonly"]?.label
                  : "Commonly Used Services"}
              </span>

              {General.commonlyUsedServices.length > 0 ? (
                General.commonlyUsedServices.map((service) => {
                  const exist = favourites[service.serviceGuideId];
                  return (
                    <MyFavoritesCard
                      style={{
                        cursor: "pointer",
                        backgroundColor: contrast?.contrastBackground
                          ? contrast?.contrastBackground
                          : "rgba(229, 239, 242, 0.7)",
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                      }}
                      onClick={() => {
                        if (service?.serviceGuidePageLink == "complaint") {
                          navigate("/complaint");
                        }
                        if (service?.serviceGuidePageLink == "movein") {
                          navigate(`/movein-registration`);
                        } else if (service?.serviceGuidePageLink == "moveout") {
                          navigate(`/moveout-termination`);
                        } else if (service?.serviceGuidePageLink == "refund") {
                          navigate(`/refund`);
                        } else if (
                          service?.serviceGuidePageLink == "applyforwwpr"
                        ) {
                          window.open(`${constants.URL.CUSTOMER_PORTAL}`);
                        } else if (
                          service?.serviceGuidePageLink == "paymentfacilities"
                        ) {
                          navigate(`/payment-plan`);
                        } else if (
                          service?.serviceGuidePageLink == "billenquiry"
                        ) {
                          setValue(1);
                        } else if (
                          service?.serviceGuidePageLink == "billpayment"
                        ) {
                          setValue(1);
                          setInnerValue(1);
                        } else if (
                          service?.serviceGuidePageLink ==
                          "Suggestionscomplaint"
                        ) {
                          navigate(`/complaint`);
                        } else if (service?.serviceGuidePageLink == "sccd") {
                          navigate(`/social-case-consideration`);
                        } else if (
                          service?.serviceGuidePageLink == "tenantnoc" ||
                          service?.serviceGuidePageLink == "ownernoc"
                        ) {
                          navigate(`/noc-apply`, { state: { login: false } });
                        }
                      }}
                    >
                      <span
                        style={{
                          lineHeight: 1,
                          fontSize: `${General.accessibility.fontSize}rem`,
                          color: contrast?.contrastColor
                            ? contrast?.contrastColor
                            : ColorAss,
                        }}                      >
                        {service.serviceGuideTitle}
                      </span>
                      {exist ? (
                        <StarIcon
                        style={{
                          fill: contrast?.contrastColor ? contrast?.contrastColor : ColorAss === "#101E8E" ? "#62AA51" : ColorAss,
                          cursor: "pointer"
                        }}
                          onClick={(e) => {
                            e.stopPropagation();
                            User.addFavourite(service?.serviceGuideId);
                          }}
                        />
                      ) : (
                        <StarBorderOutlined
                          onClick={(e) => {
                            e.stopPropagation();
                            User.addFavourite(service?.serviceGuideId);
                          }}
                          style={{
                            fill: contrast?.contrastColor ? contrast?.contrastColor : ColorAss === "#101E8E" ? "#62AA51" : ColorAss,
                            cursor: "pointer"
                          }}
                        />
                      )}
                    </MyFavoritesCard>
                  );
                })
              ) : (
                <p
                  style={{
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : ColorAss,
                    fontSize: `${General.accessibility.fontSize}rem`,
                  }}
                >
                  {General?.codeLabels["cm_dash_commonly_not"]?.label
                    ? General?.codeLabels["cm_dash_commonly_not"]?.label
                    : "Haven't used any of our services yet"}
                </p>
              )}
            </MyFavorites>
          ) : (
            ""
          )}
        </BaseCardsContainer>
      </CardsContainer>

      {!isLargeScreen ? (
        <div
          className={`my-3 py-4  pl-3`}
          style={{
            backgroundColor: contrast?.contrastBackground
              ? contrast?.contrastBackground
              : "white",
          }}
        >
          <p
            style={{
              fontSize: `${1.25 * General.accessibility.fontSize}rem`,
              color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
            }}
            className={`mb-3  slider2 pl-2`}
          >
            {General?.codeLabels["cm_dash_commonly"]?.label
              ? General?.codeLabels["cm_dash_commonly"]?.label
              : "Commonly Used Services"}
          </p>
          <Carousel2 setValue={setValue} setInnerValue={setInnerValue} data={General.commonlyUsedServices} favourites={favourites} fromRecent={true} />
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default observer(DashboardCards);
